// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {url = importMap[url] || url;return publicUrl + url;}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"iFN5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nav", ()=>Nav);
// Used by the ToC
parcelHelpers.export(exports, "SideNav", ()=>SideNav);
parcelHelpers.export(exports, "SideNavItem", ()=>SideNavItem);
parcelHelpers.export(exports, "SideNavLink", ()=>SideNavLink);
parcelHelpers.export(exports, "OnPageNav", ()=>OnPageNav);
parcelHelpers.export(exports, "MobileOnPageNav", ()=>MobileOnPageNav);
var _jsxRuntime = require("react/jsx-runtime");
var _link = require("./Link");
var _sideNav = require("@react-spectrum/s2/SideNav");
var _library = require("./library");
var _linkOut = require("../../../@react-spectrum/s2/ui-icons/LinkOut");
var _linkOutDefault = parcelHelpers.interopDefault(_linkOut);
var _s2 = require("@react-spectrum/s2");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _router = require("./Router");
'use client';
function isSectionMap(value) {
    return value instanceof Map;
}
function Nav() {
    let { pages, currentPage } = (0, _router.useRouter)();
    let [maskSize, setMaskSize] = (0, _react.useState)(0);
    let displayPage = (0, _router.usePendingPage)();
    if (currentPage.exports?.hideNav) return null;
    let currentLibrary = (0, _library.getLibraryFromPage)(displayPage);
    let sections = new Map();
    for (let page of pages){
        if (page.exports?.hideNav || page.exports?.omitFromNav) continue;
        let library = (0, _library.getLibraryFromPage)(page);
        if (currentLibrary === 'react-spectrum' && library !== currentLibrary) continue;
        // If the current library is React Aria, we only want to skip pages in React Spectrum so that include Internationalized pages in the side nav
        if (currentLibrary === 'react-aria' && library === 'react-spectrum') continue;
        let section = page.exports?.section ?? 'Components';
        let group = page.exports?.group ?? undefined;
        if (section === '' || page.exports?.isSubpage) continue;
        if (group && section) {
            let value = sections.get(group);
            let groupMap;
            if (value instanceof Map) groupMap = value;
            else groupMap = new Map();
            let groupPages = groupMap.get(section) ?? [];
            groupPages.push(page);
            groupMap.set(section, groupPages);
            sections.set(group, groupMap);
        } else if (section) {
            let value = sections.get(section);
            let sectionPages = Array.isArray(value) ? value : [];
            sectionPages.push(page);
            sections.set(section, sectionPages);
        }
    }
    let sortedSections = [
        ...sections
    ].sort((a, b)=>{
        if (a[0] === 'Overview') return -1;
        if (b[0] === 'Overview') return 1;
        return a[0].localeCompare(b[0]);
    });
    let libraryLabel = (0, _library.getLibraryLabel)(currentLibrary);
    let overviewNodes = [];
    let sectionNodes = [];
    for (let [name, pages] of sortedSections){
        if (name === 'Overview' && Array.isArray(pages)) overviewNodes = sortOverview(pages).map(leafNode);
        else if (isSectionMap(pages)) sectionNodes.push({
            id: name,
            title: name,
            children: [
                ...pages.entries()
            ].map(([sub, subPages])=>({
                    id: sub,
                    title: sub,
                    children: sortSectionPages(subPages).map(leafNode)
                }))
        });
        else sectionNodes.push({
            id: name,
            title: name,
            children: sortSectionPages(pages).map(leafNode)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        onScroll: (e)=>setMaskSize(Math.min(e.currentTarget.scrollTop, 32)),
        style: {
            maskImage: maskSize > 0 ? `linear-gradient(to bottom, transparent, black ${maskSize}px)` : undefined
        },
        className: " _Pe171 WB171 KEqCbPc171 Se171 Re171 NU2bf9171 sk171 spd171 _ta171",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sideNav.SideNav), {
            "aria-label": libraryLabel,
            selectedRoute: displayPage.url,
            defaultExpandedKeys: getDefaultExpandedKeys(currentPage),
            styles: " _ub171 _vb171 _sb171 Ma171",
            children: [
                overviewNodes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sideNav.SideNavSection), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.SideNavHeader), {
                            children: "Overview"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.Collection), {
                            items: overviewNodes,
                            children: renderNode
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.SideNavSection), {
                    "aria-label": libraryLabel,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.Collection), {
                        items: sectionNodes,
                        children: renderNode
                    })
                })
            ]
        })
    });
}
function title(page) {
    return page.exports?.title ?? page.tableOfContents?.[0]?.title ?? page.name;
}
function isIntroduction(page) {
    return page.url.endsWith('/');
}
function leafNode(page) {
    return {
        id: page.url,
        title: title(page),
        href: page.url
    };
}
function renderNode(node) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sideNav.SideNavItem), {
        id: node.id,
        textValue: node.title,
        href: node.href,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.SideNavItemContent), {
                children: node.href ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.SideNavItemLink), {
                    children: node.title
                }) : node.title
            }),
            node.children && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideNav.Collection), {
                items: node.children,
                children: renderNode
            })
        ]
    });
}
function sortSectionPages(pages) {
    return [
        ...pages
    ].filter((page)=>!page.exports?.isSubpage).sort((a, b)=>{
        let aIntro = isIntroduction(a);
        let bIntro = isIntroduction(b);
        if (aIntro && !bIntro) return -1;
        if (!aIntro && bIntro) return 1;
        return title(a).localeCompare(title(b));
    });
}
function sortOverview(pages) {
    return [
        ...pages
    ].filter((page)=>!page.exports?.isSubpage).sort((a, b)=>{
        let aIntro = a.url.endsWith('getting-started');
        let bIntro = b.url.endsWith('getting-started');
        if (aIntro && !bIntro) return -1;
        if (!aIntro && bIntro) return 1;
        return title(a).localeCompare(title(b));
    });
}
function getDefaultExpandedKeys(currentPage) {
    let keys = new Set();
    let section = currentPage.exports?.section ?? 'Components';
    let group = currentPage.exports?.group;
    if (group) {
        keys.add(group);
        keys.add(section);
    } else keys.add(section);
    return [
        ...keys,
        'Components'
    ];
}
const SideNavContext = /*#__PURE__*/ (0, _react.createContext)('');
function SideNav({ children, isNested = false }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        className: function anonymous(props) {
            let rules = " ";
            rules += ' _Gc171';
            if (props.isNested) rules += ' Tt171';
            else rules += ' Td171';
            rules += ' Qd171';
            rules += ' Sd171';
            rules += ' S6XE6sdf171';
            rules += ' Rd171';
            rules += ' JYB8I171';
            rules += ' GYB8I171';
            rules += ' IYB8I171';
            rules += ' HYB8I171';
            rules += ' sd171';
            rules += ' _ta171';
            rules += ' UH5kTnc171';
            rules += ' qH5kTnc171';
            rules += ' Za171';
            rules += ' _oa171';
            return rules;
        }({
            isNested
        }),
        children: children
    });
}
function SideNavItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        children: props.children
    });
}
function SideNavLink(props1) {
    let linkRef = (0, _react.useRef)(null);
    let shouldAutoScrollOnMount = (0, _react.useRef)(props1.isSelected);
    let selected = (0, _react.useContext)(SideNavContext);
    let { isExternal, ...linkProps } = props1;
    (0, _react.useEffect)(()=>{
        let link = linkRef.current;
        if (!link || !props1.isSelected || !shouldAutoScrollOnMount.current) return;
        shouldAutoScrollOnMount.current = false;
        link.scrollIntoView({
            block: 'start'
        });
    }, [
        props1.isSelected
    ]);
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.BaseLink), {
        ...linkProps,
        ref: linkRef,
        target: isExternal ? '_blank' : undefined,
        rel: isExternal ? 'noopener noreferrer' : undefined,
        "aria-current": props1.isSelected || selected === props1.href ? 'page' : undefined,
        style: (0, _s2.pressScale)(linkRef),
        className: function anonymous(props) {
            let rules = " ";
            if (props.isFocusVisible) rules += ' _Lf171';
            else rules += ' _Le171';
            rules += ' Oh171';
            rules += ' OlOVIhfcebS7sd171';
            rules += ' OlOVIhfcebS7sd171';
            rules += ' _Mc171';
            rules += ' _Kd171';
            rules += ' M4dY0ec171';
            rules += ' _oa171';
            rules += ' Sp171';
            rules += ' Rp171';
            rules += ' sd171';
            rules += ' eb171';
            rules += ' U1cJjHb171';
            rules += ' q1cJjHb171';
            rules += ' uk171';
            rules += ' ucJ9TBTb171';
            rules += ' ud3Euai171';
            rules += ' uea171';
            rules += ' ugb171';
            rules += ' uhd171';
            rules += ' uje171';
            rules += ' u2NhKxcl171';
            rules += ' uic171';
            rules += ' -_6BNtrc-c171';
            rules += ' vFHT6Dd171';
            if (props.isCurrent) {
                rules += ' xd171';
                rules += ' _xa171';
                rules += ' xX0cczbc171';
                rules += ' _xX0cczba171';
            } else {
                rules += ' xb171';
                rules += ' _xa171';
            }
            rules += ' _Fd171';
            rules += ' _FnuYUweb171';
            rules += ' pt171';
            rules += ' _Xa171';
            rules += ' oH5kTnc171';
            rules += ' nH5kTnc171';
            rules += ' kH5kTnc171';
            rules += ' jH5kTnc171';
            rules += ' Yd171';
            rules += ' Xb171';
            rules += ' _2b171';
            rules += ' __Mq4iaqb171';
            return rules;
        },
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: function anonymous(props) {
                            let rules = " ";
                            rules += ' ZkqjWPe171';
                            rules += ' FObNfn171';
                            rules += ' og171';
                            rules += ' ng171';
                            rules += ' kg171';
                            rules += ' jg171';
                            rules += ' Yd171';
                            rules += ' Xb171';
                            rules += ' _2b171';
                            if (props.isCurrent) rules += ' g0171';
                            else if (props.isHovered) rules += ' gw171';
                            else rules += ' g9171';
                            return rules;
                        }(renderProps)
                    }),
                    props1.children,
                    isExternal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkOutDefault.default), {
                        "aria-label": "(opens in a new tab)",
                        className: " pt171 IM171 _va171 St171 Rt171"
                    })
                ]
            })
    });
// oxlint-enable react/react-compiler
}
function useCurrentSection() {
    let { currentPage } = (0, _router.useRouter)();
    let [selected, setSelected] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        let elements = Array.from(document.querySelectorAll('article [data-anchor-link]'));
        let visible = new Set();
        let observer = new IntersectionObserver((entries)=>{
            for (let entry of entries){
                if (entry.isIntersecting) visible.add(entry.target);
                else visible.delete(entry.target);
                let firstVisible = elements.find((e)=>visible.has(e));
                if (firstVisible) setSelected('#' + firstVisible.id);
            }
        }, {
            rootMargin: '0px 0px -50% 0px'
        });
        for (let element of elements)observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        currentPage
    ]);
    return selected;
}
function OnPageNav({ children }) {
    let selected = useCurrentSection();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavContext.Provider, {
        value: selected,
        children: children
    });
}
function MobileOnPageNav({ children }) {
    let { currentPage } = (0, _router.useRouter)();
    let [selected, setSelected] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        let elements = Array.from(document.querySelectorAll('article [data-anchor-link]'));
        elements.reverse();
        let visible = new Set();
        let observer = new IntersectionObserver((entries)=>{
            for (let entry of entries)if (entry.isIntersecting) visible.add(entry.target);
            else visible.delete(entry.target);
            let lastVisible = elements.find((e)=>visible.has(e));
            if (lastVisible) setSelected('#' + lastVisible.id);
            else setSelected('#' + elements.at(-1).id);
        }, {
            rootMargin: '9999999px 0px -100% 0px',
            // @ts-ignore
            scrollMargin: '0px 0px 62px 0px',
            threshold: 0.5
        });
        for (let element of elements)observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Picker), {
        "aria-label": "Table of contents",
        value: selected,
        isQuiet: true,
        size: "L",
        children: children
    });
}

},{"0":"kr3Zp","1":"j0bDS","2":"em0fw","3":"dR1mU","4":"2SxIO","5":"aSDjJ","react/jsx-runtime":"2Is6Z","./Link":"el6b6","@react-spectrum/s2/SideNav":[["Collection","3m036"],["SideNav","jTjG8"],["SideNavHeader","jTjG8"],["SideNavItem","jTjG8"],["SideNavItemContent","jTjG8"],["SideNavItemLink","jTjG8"],["SideNavSection","jTjG8"]],"./library":"a5H2j","../../../@react-spectrum/s2/ui-icons/LinkOut":"6y2C0","@react-spectrum/s2":[["Picker","akpch"],["pressScale","8Ufux"]],"react":"a1TxN","./Router":"jI9xq","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2Is6Z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"6vHrA"}],"6vHrA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"jTjG8":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SideNav", ()=>SideNav);
parcelHelpers.export(exports, "SideNavItem", ()=>SideNavItem);
parcelHelpers.export(exports, "SideNavItemContent", ()=>SideNavItemContent);
parcelHelpers.export(exports, "SideNavSection", ()=>SideNavSection);
parcelHelpers.export(exports, "SideNavHeader", ()=>SideNavHeader);
parcelHelpers.export(exports, "SideNavItemLink", ()=>SideNavItemLink);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButtonGroup = require("./ActionButtonGroup");
var _actionMenu = require("./ActionMenu");
var _button = require("react-aria-components/Button");
var _centerBaseline = require("./CenterBaseline");
var _chevron = require("../ui-icons/Chevron");
var _chevronDefault = parcelHelpers.interopDefault(_chevron);
var _react = require("react");
var _icon = require("./Icon");
var _link = require("react-aria-components/Link");
var _navigationTree = require("react-aria-components/NavigationTree");
var _pressScale = require("./pressScale");
var _slots = require("react-aria-components/slots");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _i18Nprovider = require("react-aria/I18nProvider");
var _utils = require("./utils");
const sideNavWrapper = function anonymous(props, overrides) {
    let rules = " ";
    let minHeight = false;
    let height = false;
    let minWidth = false;
    let position = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L|F|M|K)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "M") minHeight = true;
        if (p[1] === "F") height = true;
        if (p[1] === "N") minWidth = true;
        if (p[1] === "_P") position = true;
        rules += p[0];
    }
    if (!minHeight) rules += ' Ma171';
    if (!height) rules += ' Fb171';
    if (!minWidth) rules += ' N3HJbhc171';
    rules += ' sd171';
    rules += ' _Bb171';
    rules += ' __ca171';
    if (!position) rules += ' _Pc171';
    rules += ' _Nb171';
    rules += ' Pb171';
    return rules;
};
// TODO: the below is needed so the borders of the top and bottom row isn't cut off if the TreeView is wrapped within a container by always reserving the 2px needed for the
// keyboard focus ring. Perhaps find a different way of rendering the outlines since the top of the item doesn't
// scroll into view due to how the ring is offset. Alternatively, have the tree render the top/bottom outline like it does in Listview
const tree = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    rules += ' Oh171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' _Mc171';
    rules += ' _Kb171';
    rules += ' _4c171';
    rules += ' Ma171';
    rules += ' Na171';
    rules += ' Za171';
    rules += ' Fb171';
    rules += ' Pa171';
    rules += ' _Nc171';
    rules += ' _oa171';
    rules += ' Qd171';
    rules += ' __NYB8I171';
    rules += ' -lPUMEc-ZxhYlec171';
    return rules;
};
const SideNav = /*#__PURE__*/ (0, _react.forwardRef)(function SideNav(props, ref) {
    let { children, UNSAFE_className, UNSAFE_style, selectedRoute, ...rest } = props;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: domRef,
        className: (UNSAFE_className ?? '') + sideNavWrapper(null, props.styles),
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationTree.NavigationTree), {
            ...rest,
            selectedRoute: selectedRoute,
            className: (renderProps)=>tree(renderProps),
            children: children
        })
    });
});
const treeRow = function anonymous(props) {
    let rules = " ";
    rules += ' _Le171';
    rules += ' _Pc171';
    rules += ' sd171';
    rules += ' MAyFGYc171';
    rules += ' Za171';
    rules += ' _oa171';
    rules += ' uk171';
    rules += ' ucJ9TBTb171';
    rules += ' ud3Euai171';
    rules += ' uea171';
    rules += ' ugb171';
    rules += ' uhd171';
    rules += ' uje171';
    rules += ' u2NhKxcl171';
    rules += ' uic171';
    rules += ' -_6BNtrc-c171';
    rules += ' vFHT6Dd171';
    rules += ' xb171';
    rules += ' _xa171';
    rules += ' _Fd171';
    rules += ' _FnuYUweb171';
    if (props.isPressed) rules += ' pt171';
    else if (props.isFocusVisible) rules += ' pt171';
    else if (props.isHovered) rules += ' pt171';
    else rules += ' pv171';
    rules += ' plOVIhfc6LxY9171';
    rules += ' plOVIhfc6LxY9171';
    if (props.isLink) rules += ' ry171';
    else rules += ' ri171';
    rules += ' oR3ltQc171';
    rules += ' nR3ltQc171';
    rules += ' kR3ltQc171';
    rules += ' jR3ltQc171';
    rules += ' JbCyY5d171';
    rules += ' JbYB8I171';
    rules += ' -_7qV2Ne-Tu7Fubd171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    rules += ' -M_-M4dY0ec171';
    return rules;
};
const treeCellGrid = function anonymous(props) {
    let rules = " ";
    rules += ' se171';
    rules += ' Za171';
    rules += ' Mb171';
    rules += ' _oa171';
    rules += ' _cb171';
    rules += ' eb171';
    rules += ' Dh0aa8b171';
    rules += ' EM8Mfn171';
    rules += ' CZewL8b171';
    rules += ' Rp171';
    if (props.isDisabled) rules += ' pp171';
    else if (props.isDescendantSelected) {
        if (props.isPressed) rules += ' po171';
        else if (props.isFocusVisible) rules += ' po171';
        else if (props.isHovered) rules += ' po171';
        else rules += ' pt171';
    } else if (props.isSelected) {
        if (props.isPressed) rules += ' po171';
        else if (props.isFocusVisible) rules += ' po171';
        else if (props.isHovered) rules += ' po171';
        else rules += ' pt171';
    } else {
        if (props.isPressed) rules += ' pt171';
        else if (props.isFocusVisible) rules += ' pt171';
        else if (props.isHovered) rules += ' pt171';
        else rules += ' pv171';
    }
    rules += ' plOVIhfc6LxY9171';
    rules += ' plOVIhfc6LxY9171';
    if (props.isDescendantSelected) {
        rules += ' xd171';
        rules += ' _xa171';
        rules += ' xX0cczbc171';
        rules += ' _xX0cczba171';
    } else if (props.isSelected) {
        rules += ' xd171';
        rules += ' _xa171';
        rules += ' xX0cczbc171';
        rules += ' _xX0cczba171';
    }
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    rules += ' _yb171';
    return rules;
};
const treeIcon = " z2U5Crc171 y2U5Crc171 B2U5Crc171 A2U5Crc171 Ht171 Hsu171 -_8sjo0b-t5ZbAob171";
const treeContent = " zk52g2d171 yk52g2d171 Bk52g2d171 Ak52g2d171 T3jFijd171 Q3jFijd171";
let treeRowFocusRing = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    rules += ' Oh171';
    rules += ' OlOVIhfcCp4usd171';
    rules += ' OlOVIhfcCp4usd171';
    rules += ' _Mc171';
    rules += ' _Kb171';
    rules += ' _Pa171';
    rules += ' Wr171';
    rules += ' _lr171';
    rules += ' _Ar171';
    rules += ' _zr171';
    rules += ' oH5kTnc171';
    rules += ' nH5kTnc171';
    rules += ' kH5kTnc171';
    rules += ' jH5kTnc171';
    rules += ' _9c171';
    rules += ' _Ob171';
    return rules;
};
const treeRowLink = function anonymous(props) {
    let rules = " ";
    rules += ' se171';
    rules += ' zk52g2d171';
    rules += ' yk52g2d171';
    rules += ' Bk52g2d171';
    rules += ' Ak52g2d171';
    rules += ' DPlN5qb171';
    rules += ' Cbu1Uzb171';
    rules += ' eb171';
    rules += ' Na171';
    rules += ' _Le171';
    rules += ' _Xa171';
    rules += ' p40ub4c171';
    if (props.isDisabled) rules += ' ri171';
    else rules += ' ry171';
    return rules;
};
const treeActions = " zkG38H171 ykG38H171 BkG38H171 AkG38H171 Iahikk171 HR3ltQc171";
const treeActionMenu = " z6Nrfjc171 y6Nrfjc171 B6Nrfjc171 A6Nrfjc171";
const SideNavItemLinkContext = /*#__PURE__*/ (0, _react.createContext)({});
const SideNavInternalItemContext = /*#__PURE__*/ (0, _react.createContext)({});
const SideNavItem = (props)=>{
    let [isLinkPressed, setLinkPressed] = (0, _react.useState)(false);
    let rowRef = (0, _react.useRef)(null);
    // oxlint-disable-next-line react-compiler
    let scaling = (0, _pressScale.pressScale)(rowRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavInternalItemContext.Provider, {
        value: {
            setLinkPressed
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationTree.NavigationTreeItem), {
            ...props,
            ref: rowRef,
            style: ({ isPressed })=>scaling({
                    isPressed: isLinkPressed || isPressed
                }),
            className: (renderProps)=>treeRow(renderProps)
        })
    });
};
const indicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa171';
    if (props.isHovered) rules += ' sb171';
    else if (props.isSelected) rules += ' sb171';
    else rules += ' sk171';
    if (props.isDisabled) rules += ' gH171';
    else if (props.isSelected) rules += ' g0171';
    else if (props.isHovered) rules += ' gw171';
    if (props.isDisabled) rules += ' glOVIhfcYMPQu171';
    else rules += ' glOVIhfcebS7sd171';
    if (props.isDisabled) rules += ' glOVIhfcYMPQu171';
    else rules += ' glOVIhfcebS7sd171';
    rules += ' Fd60gf171';
    rules += ' ZLvNfn171';
    rules += ' _qg171';
    rules += ' WF171';
    rules += ' _ZoL69hc171';
    rules += ' -XLHCac-ZPcYW6d171';
    rules += ' _ADzleGd171';
    rules += ' _je171';
    rules += ' og171';
    rules += ' ng171';
    rules += ' kg171';
    rules += ' jg171';
    return rules;
};
const SideNavItemContent = (props)=>{
    let { children } = props;
    let scale = (0, _utils.useScale)();
    let { setLinkPressed } = (0, _react.useContext)(SideNavInternalItemContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationTree.NavigationTreeItemContent), {
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SideNavItemContentInner, {
                ...renderProps,
                scale: scale,
                setLinkPressed: setLinkPressed,
                children: children
            })
    });
};
const SideNavItemContentInner = (props)=>{
    let { isExpanded, hasChildItems, isDisabled, isCurrent, isCurrentAncestor, isHovered, isFocusVisible, scale, setLinkPressed, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: treeRowFocusRing({
                    isFocusVisible,
                    isSelected: isCurrent
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: treeCellGrid({
                    isDisabled,
                    isSelected: isCurrent,
                    isDescendantSelected: isCurrentAncestor && !isExpanded
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: indicator({
                            isDisabled,
                            isSelected: isCurrent,
                            isHovered
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " z7fSmKc171 y7fSmKc171 B7fSmKc171 A7fSmKc171 ZecPNad171"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                        values: [
                            [
                                (0, _content.TextContext),
                                {
                                    styles: treeContent
                                }
                            ],
                            [
                                SideNavItemLinkContext,
                                {
                                    isDisabled,
                                    onPressChange: setLinkPressed
                                }
                            ],
                            [
                                (0, _icon.IconContext),
                                {
                                    render: (0, _centerBaseline.centerBaseline)({
                                        slot: 'icon',
                                        styles: treeIcon
                                    }),
                                    styles: " ZObNfn171 FObNfn171 _va171"
                                }
                            ],
                            [
                                (0, _actionButtonGroup.ActionButtonGroupContext),
                                {
                                    styles: treeActions,
                                    isDisabled,
                                    size: 'S'
                                }
                            ],
                            [
                                (0, _actionMenu.ActionMenuContext),
                                {
                                    styles: treeActionMenu,
                                    isQuiet: true,
                                    isDisabled,
                                    size: 'S'
                                }
                            ]
                        ],
                        children: typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                            children: children
                        }) : children
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandableRowChevron, {
                isDisabled: isDisabled,
                isExpanded: isExpanded,
                scale: scale,
                isHidden: !hasChildItems
            })
        ]
    });
};
const expandButton = function anonymous(props) {
    let rules = " ";
    rules += ' z8dW5Qb171';
    rules += ' y8dW5Qb171';
    rules += ' B8dW5Qb171';
    rules += ' A8dW5Qb171';
    if (props.isDisabled) {
        rules += ' pp171';
        rules += ' plOVIhfcYMPQu171';
        rules += ' plOVIhfcYMPQu171';
    } else rules += ' p40ub4c171';
    rules += ' F4dY0ec171';
    rules += ' Z4dY0ec171';
    rules += ' sd171';
    rules += ' _wb171';
    rules += ' _cb171';
    rules += ' _Ca171';
    rules += ' _Le171';
    rules += ' ri171';
    if (props.isExpanded) {
        if (props.isRTL) rules += ' _Za171';
        else rules += ' _Zb171';
    }
    rules += ' Td171';
    rules += ' Qd171';
    rules += ' Sd171';
    rules += ' Rd171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    rules += ' g9171';
    rules += ' _je171';
    rules += ' __ca171';
    if (props.isHidden) rules += ' _6b171';
    return rules;
};
function ExpandableRowChevron(props1) {
    let expandButtonRef = (0, _react.useRef)(null);
    let [fullProps, ref] = (0, _slots.useContextProps)({
        ...props1,
        slot: 'chevron'
    }, expandButtonRef, (0, _button.ButtonContext));
    let { isExpanded, scale, isHidden } = fullProps;
    let { direction } = (0, _i18Nprovider.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ...props1,
        ref: ref,
        slot: "chevron",
        className: (renderProps)=>expandButton({
                ...renderProps,
                isExpanded,
                isRTL: direction === 'rtl',
                scale,
                isHidden
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronDefault.default), {
            className: function anonymous(props) {
                let rules = " ";
                if (props.direction === "rtl") {
                    rules += ' -Z4Pn4c-a171';
                    rules += ' __Ha171';
                } else if (props.direction === "ltr") {
                    rules += ' -Z4Pn4c-b171';
                    rules += ' __Ha171';
                }
                if (props.direction === "rtl") {
                    rules += ' -_04Pn4c-a171';
                    rules += ' __Ha171';
                } else if (props.direction === "ltr") {
                    rules += ' -_04Pn4c-b171';
                    rules += ' __Ha171';
                }
                rules += ' -_8sjo0b-t5ZbAob171';
                return rules;
            }({
                direction
            })
        })
    });
}
function SideNavSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationTree.NavigationTreeSection), {
        ...props,
        className: " J6jNkOds7Vxmb171",
        children: props.children
    });
}
const SideNavHeader = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationTree.NavigationTreeHeader), {
        className: " uk171 ucJ9TBTb171 ud3Euai171 uea171 ugb171 uhd171 uje171 u2NhKxcl171 uic171 -_6BNtrc-b171 vFHT6Dd171 xc171 _xa171 _Fd171 _FnuYUweb171 pn171 Sv171 G9cPfn171 FRuFGYc171 -F_-FxhYlec171",
        children: props.children
    });
};
const SideNavItemLink = (props)=>{
    let { children } = props;
    let linkFocus = (0, _react.useContext)(SideNavItemLinkContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ...linkFocus,
        className: treeRowLink({
            isDisabled: linkFocus.isDisabled
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
            values: [
                [
                    (0, _content.TextContext),
                    {
                        styles: treeContent
                    }
                ],
                [
                    (0, _icon.IconContext),
                    {
                        render: (0, _centerBaseline.centerBaseline)({
                            slot: 'icon',
                            styles: treeIcon
                        }),
                        styles: " ZObNfn171 FObNfn171 _va171"
                    }
                ]
            ],
            children: typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                children: children
            }) : children
        })
    });
};

},{"0":"4U5Iq","1":"7loLa","2":"2S62b","3":"iqpvi","4":"7YwZQ","5":"8qtwU","6":"cMDQy","7":"dHPKW","8":"ln5hh","9":"ebHN5","10":"dyErb","11":"bbRkH","12":"4WBl7","13":"1TTyn","14":"hfU7E","15":"fi82m","16":"fXGVN","17":"9Xfuy","react/jsx-runtime":"2Is6Z","./ActionButtonGroup":"1RyqL","./ActionMenu":"3fSPo","react-aria-components/Button":"9G5XO","./CenterBaseline":"1vpL9","../ui-icons/Chevron":"1904U","react":"a1TxN","./Icon":"jQAJE","react-aria-components/Link":"fOCdV","react-aria-components/NavigationTree":"fZs1w","./pressScale":"8Ufux","react-aria-components/slots":"bA6Cz","./Content":"10r6w","./useDOMRef":"9tqah","react-aria/I18nProvider":"l34Wn","./utils":"9papc","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4U5Iq":[function() {},{}],"7loLa":[function() {},{}],"2S62b":[function() {},{}],"iqpvi":[function() {},{}],"7YwZQ":[function() {},{}],"8qtwU":[function() {},{}],"cMDQy":[function() {},{}],"dHPKW":[function() {},{}],"ln5hh":[function() {},{}],"ebHN5":[function() {},{}],"dyErb":[function() {},{}],"bbRkH":[function() {},{}],"4WBl7":[function() {},{}],"1TTyn":[function() {},{}],"hfU7E":[function() {},{}],"fi82m":[function() {},{}],"fXGVN":[function() {},{}],"9Xfuy":[function() {},{}],"a1TxN":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"4tF2f"}],"4tF2f":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray;
function noop() {}
var ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Activity = REACT_ACTIVITY_TYPE;
exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cacheSignal = function() {
    return null;
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.2.4";

},{}],"fZs1w":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavigationTreeContext", ()=>NavigationTreeContext);
parcelHelpers.export(exports, "NavigationTreeItemStateContext", ()=>NavigationTreeItemStateContext);
parcelHelpers.export(exports, "NavigationTree", ()=>NavigationTree);
parcelHelpers.export(exports, "NavigationTreeItem", ()=>NavigationTreeItem);
parcelHelpers.export(exports, "NavigationTreeItemContent", ()=>NavigationTreeItemContent);
/**
 * A NavigationTreeSection represents a section within a NavigationTree.
 */ parcelHelpers.export(exports, "NavigationTreeSection", ()=>NavigationTreeSection);
/**
 * A NavigationTreeHeader renders the header of a NavigationTreeSection.
 */ parcelHelpers.export(exports, "NavigationTreeHeader", ()=>NavigationTreeHeader);
var _utils = require("./utils");
var _getScrollParent = require("react-aria/private/utils/getScrollParent");
var _link = require("./Link");
var _domfunctions = require("react-aria/private/utils/shadowdom/DOMFunctions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scrollIntoView = require("react-aria/private/utils/scrollIntoView");
var _tree = require("./Tree");
var _useObjectRef = require("react-aria/useObjectRef");
const NavigationTreeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalNavigationTreeContext = /*#__PURE__*/ (0, _react.createContext)({});
const NavigationTreeItemLinkContext = /*#__PURE__*/ (0, _react.createContext)({});
const NavigationTreeItemStateContext = /*#__PURE__*/ (0, _react.createContext)({
    isCurrentAncestor: false
});
const NavigationTree = /*#__PURE__*/ (0, _react.forwardRef)(function NavigationTree(props, ref) {
    [props, ref] = (0, _utils.useContextProps)(props, ref, NavigationTreeContext);
    let { className, style, children, selectedRoute, ...rest } = props;
    let syncedRouteRef = (0, _react.useRef)(undefined);
    let treeRef = (0, _useObjectRef.useObjectRef)(ref);
    let context = (0, _react.useMemo)(()=>({
            selectedRoute,
            syncedRouteRef,
            treeRef
        }), [
        selectedRoute,
        treeRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalNavigationTreeContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tree.Tree), {
        ...rest,
        ref: treeRef,
        className: className ?? 'react-aria-NavigationTree',
        style: style,
        selectionMode: "none",
        keyboardNavigationBehavior: "tab"
    }, children));
});
const NavigationTreeItem = /*#__PURE__*/ (0, _react.forwardRef)(function NavigationTreeItem(props, ref) {
    let { href, hrefLang, target, rel, download, ping, referrerPolicy, routerOptions, className, style, render, ...rest } = props;
    let { selectedRoute, treeRef } = (0, _react.useContext)(InternalNavigationTreeContext);
    let hasLink = href != null && href.length > 0;
    let isCurrent = hasLink && href === selectedRoute;
    let [isLinkFocused, setLinkFocused] = (0, _react.useState)(false);
    // Additional render props NavigationTreeItem adds to what TreeItem already provides.
    let getItemRenderProps = (renderProps)=>({
            ...renderProps,
            isCurrent,
            isCurrentAncestor: hasSelectedDescendant(renderProps.id, renderProps.state, selectedRoute),
            isFocusVisible: renderProps.isFocusVisible || renderProps.isFocusVisibleWithin && isLinkFocused
        });
    let objRef = (0, _useObjectRef.useObjectRef)(ref);
    (0, _react.useEffect)(()=>{
        if (isCurrent && objRef.current) {
            let scrollParent = (0, _getScrollParent.getScrollParent)(objRef.current, true);
            // Only scroll the tree's own scroll container into view — never an outer ancestor such as the
            // page. When the tree isn't its own scroll container the nearest scroll parent is outside the
            // tree, so we skip rather than hijack the surrounding scroll position.
            let treeRoot = treeRef?.current;
            if (treeRoot && (0, _domfunctions.nodeContains)(treeRoot, scrollParent)) (0, _scrollIntoView.scrollIntoView)(scrollParent, objRef.current, {
                block: 'center'
            });
        }
    }, [
        isCurrent,
        objRef,
        treeRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationTreeItemLinkContext.Provider, {
        value: {
            href,
            hrefLang,
            target,
            rel,
            download,
            ping,
            referrerPolicy,
            routerOptions,
            isCurrent,
            isLinkFocused,
            setLinkFocused
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tree.TreeItem), {
        ...rest,
        ref: objRef,
        href: href,
        focusMode: hasLink ? 'child' : undefined,
        allowsArrowNavigation: true,
        "data-current": isCurrent || undefined,
        className: typeof className === 'function' ? (renderProps)=>className(getItemRenderProps(renderProps)) : className ?? 'react-aria-NavigationTreeItem',
        style: typeof style === 'function' ? (renderProps)=>style(getItemRenderProps(renderProps)) : style,
        render: (domProps, renderProps)=>{
            let values = getItemRenderProps(renderProps);
            let { children: rowChildren, ...domRest } = domProps;
            let dataProps = {
                'data-focus-visible': values.isFocusVisible || undefined,
                'data-current-ancestor': values.isCurrentAncestor || undefined
            };
            let content = /*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationTreeItemStateContext.Provider, {
                value: {
                    isCurrentAncestor: values.isCurrentAncestor
                }
            }, rowChildren);
            return typeof render === 'function' ? render({
                ...domRest,
                ...dataProps,
                children: content
            }, values) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
                ...domRest,
                ...dataProps
            }, content);
        }
    }));
});
// The collection key of the item whose href matches `route`, or null.
function findKeyForRoute(collection, route) {
    for (let key of collection.getKeys()){
        if (collection.getItem(key)?.props?.href === route) return key;
    }
    return null;
}
// Walks up from `key` to the closest ancestor that is actually rendered (all ancestors expanded).
// Returns `key` unchanged when already visible. A collapsed ancestor hides everything beneath it,
// so the highest collapsed ancestor is the closest visible row.
function closestVisibleKey(collection, expandedKeys, key) {
    let target = key;
    let node = collection.getItem(key);
    while(node?.parentKey != null){
        let parent = collection.getItem(node.parentKey);
        if (parent?.type === 'item' && !expandedKeys.has(node.parentKey)) target = node.parentKey;
        node = parent;
    }
    return target;
}
// Moves the tree's focused key to the item matching selectedRoute. Runs when the route or the
// collection changes; the shared syncedRouteRef dedupes across items so it fires once per change.
function useRouteFocusSync({ state }) {
    let { selectedRoute, syncedRouteRef } = (0, _react.useContext)(InternalNavigationTreeContext);
    let { collection, selectionManager, expandedKeys } = state;
    (0, _react.useEffect)(()=>{
        if (selectedRoute == null || syncedRouteRef == null || syncedRouteRef.current === selectedRoute) return;
        let key = findKeyForRoute(collection, selectedRoute);
        if (key != null) {
            key = closestVisibleKey(collection, expandedKeys, key);
            syncedRouteRef.current = selectedRoute;
            selectionManager.setFocusedKey(key);
        }
    }, [
        selectedRoute,
        collection,
        expandedKeys,
        syncedRouteRef,
        selectionManager
    ]);
}
// Cache so each row doesn't have to walk up the tree every time.
let selectedAncestorsCache = new WeakMap();
// The set of collection keys that are ancestors of the item matching `selectedRoute`.
function getSelectedAncestors(state, selectedRoute) {
    let { collection } = state;
    let cached = selectedAncestorsCache.get(collection);
    if (cached && cached.selection === selectedRoute) return cached.ancestors;
    let matchKey = findKeyForRoute(collection, selectedRoute);
    let ancestors = new Set();
    let node = matchKey != null ? collection.getItem(matchKey) : null;
    while(node?.parentKey != null && !ancestors.has(node.parentKey)){
        ancestors.add(node.parentKey);
        node = collection.getItem(node.parentKey);
    }
    selectedAncestorsCache.set(collection, {
        selection: selectedRoute,
        ancestors
    });
    return ancestors;
}
// Whether the row `id` is an ancestor of the item matching `selectedRoute`.
function hasSelectedDescendant(id, state, selectedRoute) {
    if (id == null || selectedRoute == null || !state) return false;
    return getSelectedAncestors(state, selectedRoute).has(id);
}
function NavigationTreeItemContent(props) {
    let linkCtx = (0, _react.useContext)(NavigationTreeItemLinkContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tree.TreeItemContent), props, (treeRenderProps)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(NavigationTreeItemContentInner, {
            treeRenderProps: treeRenderProps,
            linkCtx: linkCtx,
            children: props.children
        }));
}
function NavigationTreeItemContentInner(props) {
    let { treeRenderProps, linkCtx, children } = props;
    let { isCurrent, isLinkFocused, setLinkFocused, ...linkProps } = linkCtx;
    let { state, isFocusVisible, isFocusVisibleWithin, id, hasChildItems } = treeRenderProps;
    let { isCurrentAncestor } = (0, _react.useContext)(NavigationTreeItemStateContext);
    useRouteFocusSync({
        state
    });
    // isFocusVisible follows the link: true when the row itself is keyboard focused, or when a child
    // is keyboard focused and that child is the link (not another button/action).
    let linkFocusVisible = isFocusVisible || isFocusVisibleWithin && !!isLinkFocused;
    let values = {
        ...treeRenderProps,
        isCurrent: !!isCurrent,
        isCurrentAncestor,
        isFocusVisible: linkFocusVisible
    };
    let renderChildren = typeof children === 'function' ? children(values) : children;
    // Provide onFocusChange so the link reports its focus up to NavigationTreeItem.
    let linkContextValue = {
        ...linkProps,
        'aria-current': isCurrent ? 'page' : undefined,
        onFocusChange: setLinkFocused,
        onPress: linkProps.href == null && hasChildItems ? ()=>state.toggleKey(id) : undefined
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _link.LinkContext),
                linkContextValue
            ]
        ]
    }, renderChildren);
}
function NavigationTreeSection(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tree.TreeSection), {
        className: "react-aria-NavigationTreeSection",
        ...props
    }, props.children);
}
function NavigationTreeHeader(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tree.TreeHeader), {
        className: "react-aria-NavigationTreeHeader",
        ...props
    }, props.children);
}

},{"./utils":"bA6Cz","react-aria/private/utils/getScrollParent":"a1eud","./Link":"fOCdV","react-aria/private/utils/shadowdom/DOMFunctions":"93ERU","react":"a1TxN","react-aria/private/utils/scrollIntoView":"cf8Zu","./Tree":"kwlwT","react-aria/useObjectRef":"hJ6Rk","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kwlwT":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TreeContext", ()=>TreeContext);
parcelHelpers.export(exports, "TreeStateContext", ()=>TreeStateContext);
parcelHelpers.export(exports, "Tree", ()=>Tree);
parcelHelpers.export(exports, "TreeItemContent", ()=>TreeItemContent);
parcelHelpers.export(exports, "TreeItemContentContext", ()=>TreeItemContentContext);
parcelHelpers.export(exports, "TreeItem", ()=>TreeItem);
parcelHelpers.export(exports, "TreeLoadMoreItem", ()=>TreeLoadMoreItem);
parcelHelpers.export(exports, "TreeSection", ()=>TreeSection);
parcelHelpers.export(exports, "TreeHeader", ()=>TreeHeader);
var _useTree = require("react-aria/useTree");
var _baseCollection = require("react-aria/private/collections/BaseCollection");
var _button = require("./Button");
var _checkbox = require("./Checkbox");
var _utils = require("./utils");
var _collection = require("react-aria/Collection");
var _collectionBuilder = require("react-aria/CollectionBuilder");
var _collection1 = require("./Collection");
var _dragAndDrop = require("./DragAndDrop");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _focusScope = require("react-aria/FocusScope");
var _gridList = require("./GridList");
var _inertValue = require("react-aria/private/utils/inertValue");
var _listKeyboardDelegate = require("react-aria/ListKeyboardDelegate");
var _useLoadMoreSentinel = require("react-aria/private/utils/useLoadMoreSentinel");
var _mergeProps = require("react-aria/mergeProps");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectionIndicator = require("./SelectionIndicator");
var _sharedElementTransition = require("./SharedElementTransition");
var _treeDropTargetDelegate = require("./TreeDropTargetDelegate");
var _useTreeState = require("react-stately/useTreeState");
var _useCachedChildren = require("react-aria/private/collections/useCachedChildren");
var _useCollator = require("react-aria/useCollator");
var _useControlledState = require("react-stately/useControlledState");
var _useFocusRing = require("react-aria/useFocusRing");
var _useGridList = require("react-aria/useGridList");
var _useHover = require("react-aria/useHover");
var _useId = require("react-aria/useId");
var _i18Nprovider = require("react-aria/I18nProvider");
var _useObjectRef = require("react-aria/useObjectRef");
var _visuallyHidden = require("react-aria/VisuallyHidden");
class TreeCollection extends (0, _baseCollection.BaseCollection) {
    withExpandedKeys(lastExpandedKeys, expandedKeys) {
        let collection = this.clone();
        collection.expandedKeys = expandedKeys;
        // Clone ancestor section nodes so React knows to re-render since the same item won't cause a new render but a clone creating a new object with the same value will
        // Without this change, the items won't expand and collapse when virtualized inside a section
        TreeCollection.cloneAncestorSections(expandedKeys, lastExpandedKeys, collection);
        TreeCollection.cloneAncestorSections(lastExpandedKeys, expandedKeys, collection);
        collection.frozen = this.frozen;
        return collection;
    }
    // diff lastExpandedKeys and expandedKeys so we only clone what has changed
    static cloneAncestorSections(keys, excludeSet, collection) {
        for (let key of keys)if (!excludeSet.has(key)) {
            let currentKey = key;
            while(currentKey != null){
                let item = collection.getItem(currentKey);
                if (item?.type === 'section') {
                    collection.keyMap.set(currentKey, item.clone());
                    break;
                } else currentKey = item?.parentKey ?? null;
            }
        }
    }
    *[Symbol.iterator]() {
        let firstKey = this.getFirstKey();
        let node = firstKey != null ? this.getItem(firstKey) : null;
        while(node){
            yield node;
            if (node.type === 'section') node = node.nextKey != null ? this.getItem(node.nextKey) : null;
            else {
                // This will include both item and content nodes
                // We handle the content nodes in useCollectionRenderer and ListLayout
                let key = this.getKeyAfter(node.key);
                node = key != null ? this.getItem(key) : null;
            }
        }
    }
    getLastKey() {
        // Find the deepest expanded child. We don't use collection.getLastKey() here
        // because that will return the deepest child regardless of expandedKeys.
        // Instead, start from the last top-level key and walk down.
        let key = this.lastKey;
        if (key == null) return null;
        let node = this.getItem(key);
        while(node?.lastChildKey != null && (node.type !== 'item' || this.expandedKeys.has(node.key)))node = this.getItem(node.lastChildKey);
        return node?.key;
    }
    getKeyAfter(key) {
        let node = this.getItem(key);
        if (!node) return null;
        if ((this.expandedKeys.has(node.key) || node.type !== 'item') && node.firstChildKey != null) return node.firstChildKey;
        while(node){
            if (node.nextKey != null) return node.nextKey;
            if (node.parentKey != null) node = this.getItem(node.parentKey);
            else return null;
        }
        return null;
    }
    getKeyBefore(key) {
        let node = this.getItem(key);
        if (!node) return null;
        if (node.prevKey != null) {
            node = this.getItem(node.prevKey);
            // If the lastChildKey is expanded, check its lastChildKey
            while(node && (node.type !== 'item' || this.expandedKeys.has(node.key)) && node.lastChildKey != null)node = this.getItem(node.lastChildKey);
            return node?.key ?? null;
        }
        return node.parentKey;
    }
    getChildren(key) {
        let self = this;
        return {
            *[Symbol.iterator] () {
                let parent = self.getItem(key);
                let node = parent?.firstChildKey != null ? self.getItem(parent.firstChildKey) : null;
                if (parent && parent.type === 'section' && node) // Stop once either the node is null or the node is the parent's sibling
                while(node && node.key !== parent.nextKey){
                    yield self.getItem(node.key);
                    // This will include content nodes which we skip in ListLayout
                    let key = self.getKeyAfter(node.key);
                    node = key != null ? self.getItem(key) : null;
                }
                else while(node){
                    yield node;
                    node = node.nextKey != null ? self.getItem(node.nextKey) : null;
                }
            }
        };
    }
    getTextValue(key) {
        let item = this.getItem(key);
        return item ? item.textValue : '';
    }
    constructor(...args){
        super(...args), this.expandedKeys = new Set();
    }
}
const TreeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const TreeStateContext = /*#__PURE__*/ (0, _react.createContext)(null);
const Tree = /*#__PURE__*/ (0, _react.forwardRef)(function Tree(props, ref) {
    // Render the portal first so that we have the collection by the time we render the DOM in SSR.
    [props, ref] = (0, _utils.useContextProps)(props, ref, TreeContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collectionBuilder.CollectionBuilder), {
        content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection.Collection), props),
        createCollection: ()=>new TreeCollection()
    }, (collection)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(TreeInner, {
            props: props,
            collection: collection,
            treeRef: ref
        }));
});
const EXPANSION_KEYS = {
    expand: {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    collapse: {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function TreeInner({ props, collection, treeRef: ref }) {
    const { dragAndDropHooks } = props;
    let { direction } = (0, _i18Nprovider.useLocale)();
    let collator = (0, _useCollator.useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let hasDragHooks = !!dragAndDropHooks?.useDraggableCollectionState;
    let hasDropHooks = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, _react.useRef)(hasDragHooks);
    let dropHooksProvided = (0, _react.useRef)(hasDropHooks);
    (0, _react.useEffect)(()=>{
        if (dragHooksProvided.current !== hasDragHooks) console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== hasDropHooks) console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
    }, [
        hasDragHooks,
        hasDropHooks
    ]);
    let { selectionMode = 'none', expandedKeys: propExpandedKeys, defaultExpandedKeys: propDefaultExpandedKeys, onExpandedChange, disabledBehavior = 'all' } = props;
    let { CollectionRoot, isVirtualized, layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate } = (0, _react.useContext)((0, _collection1.CollectionRendererContext));
    // Kinda annoying that we have to replicate this code here as well as in useTreeState, but don't want to add
    // flattenCollection stuff to useTreeState. Think about this later
    let [expandedKeys, setExpandedKeys] = (0, _useControlledState.useControlledState)(propExpandedKeys ? new Set(propExpandedKeys) : undefined, propDefaultExpandedKeys ? new Set(propDefaultExpandedKeys) : new Set(), onExpandedChange);
    let [lastCollection, setLastCollection] = (0, _react.useState)(collection);
    let [lastExpandedKeys, setLastExpandedKeys] = (0, _react.useState)(expandedKeys);
    let [flattenedCollection, setFlattenedCollection] = (0, _react.useState)(()=>collection.withExpandedKeys(lastExpandedKeys, expandedKeys));
    // if the lastExpandedKeys is not the same as the currentExpandedKeys or the collection has changed, then run this
    if (!areSetsEqual(lastExpandedKeys, expandedKeys) || collection !== lastCollection) {
        setFlattenedCollection(collection.withExpandedKeys(lastExpandedKeys, expandedKeys));
        setLastCollection(collection);
        setLastExpandedKeys(expandedKeys);
    }
    let state = (0, _useTreeState.useTreeState)({
        ...props,
        selectionMode,
        expandedKeys,
        onExpandedChange: setExpandedKeys,
        collection: flattenedCollection,
        children: undefined,
        disabledBehavior
    });
    let { gridProps } = (0, _useTree.useTree)({
        ...props,
        isVirtualized,
        layoutDelegate
    }, state, ref);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, _react.useRef)(null);
    if (hasDragHooks && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: state.collection,
            selectionManager: state.selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        // oxlint-disable-next-line react/react-compiler
        dragAndDropHooks.useDraggableCollection({}, dragState, ref);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    let [treeDropTargetDelegate] = (0, _react.useState)(()=>new (0, _treeDropTargetDelegate.TreeDropTargetDelegate)());
    if (hasDropHooks && dragAndDropHooks) {
        // oxlint-disable-next-line react/react-compiler
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: state.collection,
            selectionManager: state.selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(state.collection, ref, {
            direction
        });
        treeDropTargetDelegate.setup(dropTargetDelegate, state, direction);
        let keyboardDelegate = new (0, _listKeyboardDelegate.ListKeyboardDelegate)({
            collection: state.collection,
            collator,
            ref,
            disabledKeys: state.selectionManager.disabledKeys,
            disabledBehavior: state.selectionManager.disabledBehavior,
            direction,
            layoutDelegate
        });
        // oxlint-disable-next-line react/react-compiler
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate,
            dropTargetDelegate: treeDropTargetDelegate,
            onDropActivate: (e)=>{
                // Expand collapsed item when dragging over. For keyboard, allow collapsing.
                if (e.target.type === 'item') {
                    let key = e.target.key;
                    let item = state.collection.getItem(key);
                    let isExpanded = expandedKeys.has(key);
                    if (item && item.hasChildNodes && (!isExpanded || dragAndDropHooks?.isVirtualDragging?.())) state.toggleKey(key);
                }
            },
            onKeyDown: (e)=>{
                let target = dropState?.target;
                if (target && target.type === 'item' && target.dropPosition === 'on') {
                    let item = state.collection.getItem(target.key);
                    if (e.key === EXPANSION_KEYS['expand'][direction] && item?.hasChildNodes && !state.expandedKeys.has(target.key)) state.toggleKey(target.key);
                    else if (e.key === EXPANSION_KEYS['collapse'][direction] && item?.hasChildNodes && state.expandedKeys.has(target.key)) state.toggleKey(target.key);
                }
            }
        }, dropState, ref);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let isTreeDraggable = !!(hasDragHooks && !dragState?.isDisabled);
    let { focusProps, isFocused, isFocusVisible } = (0, _useFocusRing.useFocusRing)();
    let renderValues = {
        isEmpty: state.collection.size === 0,
        isFocused,
        isFocusVisible,
        isDropTarget: isRootDropTarget,
        selectionMode: state.selectionManager.selectionMode,
        allowsDragging: !!isTreeDraggable,
        state
    };
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-Tree',
        values: renderValues
    });
    let emptyState = null;
    if (state.collection.size === 0 && props.renderEmptyState) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let { isEmpty, ...values } = renderValues;
        let content = props.renderEmptyState({
            ...values
        });
        let treeGridRowProps = {
            'aria-level': 1
        };
        emptyState = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            role: "row",
            style: {
                display: 'contents'
            },
            ...treeGridRowProps
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            role: "gridcell",
            style: {
                display: 'contents'
            }
        }, content));
    }
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusScope.FocusScope), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _mergeProps.mergeProps)(DOMProps, renderProps, gridProps, focusProps, droppableCollection?.collectionProps),
        ref: ref,
        slot: props.slot || undefined,
        "data-empty": state.collection.size === 0 || undefined,
        "data-focused": isFocused || undefined,
        "data-drop-target": isRootDropTarget || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode,
        "data-allows-dragging": !!isTreeDraggable || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                TreeStateContext,
                state
            ],
            [
                (0, _dragAndDrop.DragAndDropContext),
                {
                    dragAndDropHooks,
                    dragState,
                    dropState
                }
            ],
            [
                (0, _dragAndDrop.DropIndicatorContext),
                {
                    render: TreeDropIndicatorWrapper
                }
            ]
        ]
    }, hasDropHooks && /*#__PURE__*/ (0, _reactDefault.default).createElement(RootDropIndicator, null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sharedElementTransition.SharedElementTransition), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionRoot, {
        collection: state.collection,
        persistedKeys: (0, _dragAndDrop.useDndPersistedKeys)(state.selectionManager, dragAndDropHooks, dropState),
        scrollRef: ref,
        renderDropIndicator: (0, _dragAndDrop.useRenderDropIndicator)(dragAndDropHooks, dropState)
    }))), emptyState)), dragPreview);
}
class TreeContentNode extends (0, _baseCollection.CollectionNode) {
    static{
        this.type = 'content';
    }
}
const TreeItemContent = /*#__PURE__*/ (0, _collectionBuilder.createLeafComponent)(TreeContentNode, function TreeItemContent(props) {
    let values = (0, _react.useContext)(TreeItemContentContext);
    let renderProps = (0, _utils.useRenderProps)({
        children: props.children,
        values
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collection1.CollectionRendererContext).Provider, {
        value: (0, _collection1.DefaultCollectionRenderer)
    }, renderProps.children);
});
const TreeItemContentContext = /*#__PURE__*/ (0, _react.createContext)(null);
class TreeItemNode extends (0, _baseCollection.CollectionNode) {
    static{
        this.type = 'item';
    }
}
const TreeItem = /*#__PURE__*/ (0, _collectionBuilder.createBranchComponent)(TreeItemNode, (props, ref, item)=>{
    let state = (0, _react.useContext)(TreeStateContext);
    ref = (0, _useObjectRef.useObjectRef)(ref);
    let { dragAndDropHooks, dragState, dropState } = (0, _react.useContext)((0, _dragAndDrop.DragAndDropContext));
    let isDraggable = dragState && !(dragState.isDisabled || dragState.selectionManager.isDisabled(item.key));
    // TODO: remove this when we support description in tree row
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { rowProps, gridCellProps, expandButtonProps, descriptionProps, ...states } = (0, _useTree.useTreeItem)({
        node: item,
        shouldSelectOnPressUp: !!dragState,
        focusMode: props.focusMode,
        allowsArrowNavigation: props.allowsArrowNavigation
    }, state, ref);
    let isExpanded = rowProps['aria-expanded'] === true;
    let hasChildItems = props.hasChildItems || [
        ...state.collection.getChildren(item.key)
    ]?.length > 1;
    let level = rowProps['aria-level'] || 1;
    let { hoverProps, isHovered } = (0, _useHover.useHover)({
        // because of https://bugs.webkit.org/show_bug.cgi?id=214609, supporting hover styles when a item is ONLY isDraggable
        // results in hover styles sticking around after a reorder/drop operation...
        isDisabled: !states.allowsSelection && !states.hasAction && !isDraggable,
        onHoverStart: props.onHoverStart,
        onHoverChange: props.onHoverChange,
        onHoverEnd: props.onHoverEnd
    });
    let { isFocusVisible, focusProps } = (0, _useFocusRing.useFocusRing)();
    let { isFocusVisible: isFocusVisibleWithin, focusProps: focusWithinProps } = (0, _useFocusRing.useFocusRing)({
        within: true
    });
    let { checkboxProps } = (0, _useGridList.useGridListSelectionCheckbox)({
        key: item.key
    }, state);
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasDragButton: true
    }, dragState);
    let dropIndicator = null;
    let expandButtonRef = (0, _react.useRef)(null);
    let dropIndicatorRef = (0, _react.useRef)(null);
    let activateButtonRef = (0, _react.useRef)(null);
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    if (dropState && dragAndDropHooks) dropIndicator = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        },
        activateButtonRef
    }, dropState, dropIndicatorRef);
    let isDragging = dragState && dragState.isDragging(item.key);
    let isDropTarget = dropIndicator?.isDropTarget;
    let selectionMode = state.selectionManager.selectionMode;
    let selectionBehavior = state.selectionManager.selectionBehavior;
    let renderPropValues = (0, _reactDefault.default).useMemo(()=>({
            ...states,
            isHovered,
            isFocusVisible,
            isExpanded,
            hasChildItems,
            level,
            selectionMode,
            selectionBehavior,
            isFocusVisibleWithin,
            state,
            id: item.key,
            allowsDragging: !!dragState,
            isDragging,
            isDropTarget
        }), [
        states,
        isHovered,
        isFocusVisible,
        isExpanded,
        hasChildItems,
        level,
        isFocusVisibleWithin,
        state,
        item.key,
        dragState,
        isDragging,
        isDropTarget,
        selectionBehavior,
        selectionMode
    ]);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-TreeItem',
        defaultStyle: {
            // @ts-ignore
            '--tree-item-level': level
        },
        values: renderPropValues
    });
    (0, _react.useEffect)(()=>{
        item.textValue;
    }, [
        item.textValue
    ]);
    (0, _react.useEffect)(()=>{
        hasChildItems && expandButtonRef.current;
    // eslint-disable-next-line
    }, []);
    let dragButtonRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        dragState && dragButtonRef.current;
    // eslint-disable-next-line
    }, []);
    let children = (0, _useCachedChildren.useCachedChildren)({
        items: state.collection.getChildren(item.key),
        children: (item)=>{
            switch(item.type){
                case 'content':
                    return item.render(item);
                // Skip item since we don't render the nested rows as children of the parent row, the flattened collection
                // will render them each as siblings instead
                case 'loader':
                case 'item':
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
                default:
                    throw new Error('Unsupported element type in TreeRow: ' + item.type);
            }
        }
    });
    let activateButtonId = (0, _useId.useId)();
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, dropIndicator && !dropIndicator.isHidden && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-level": rowProps['aria-level'],
        "aria-expanded": rowProps['aria-expanded'],
        "aria-label": dropIndicator.dropIndicatorProps['aria-label']
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell",
        "aria-colindex": 1,
        style: {
            display: 'contents'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicator.dropIndicatorProps,
        ref: dropIndicatorRef
    }), rowProps['aria-expanded'] != null ? // Button to allow touch screen reader users to expand the item while dragging.
    /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        id: activateButtonId,
        "aria-label": expandButtonProps['aria-label'],
        "aria-labelledby": `${activateButtonId} ${rowProps.id}`,
        tabIndex: -1,
        ref: activateButtonRef
    }) : null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _mergeProps.mergeProps)(DOMProps, rowProps, focusProps, hoverProps, focusWithinProps, draggableItem?.dragProps),
        ...renderProps,
        ref: ref,
        // TODO: missing selectionBehavior, hasAction and allowsSelection data attribute equivalents (available in renderProps). Do we want those?
        "data-expanded": hasChildItems && isExpanded || undefined,
        "data-has-child-items": hasChildItems || undefined,
        "data-level": level,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode,
        "data-allows-dragging": !!dragState || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": isDropTarget || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        style: {
            display: 'contents'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _checkbox.CheckboxContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            [
                (0, _checkbox.CheckboxFieldContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        selection: checkboxProps
                    }
                }
            ],
            // TODO: support description in the tree row
            // TODO: don't think I need to pass isExpanded to the button here since it can be sourced from the renderProps? Might be worthwhile passing it down?
            [
                (0, _button.ButtonContext),
                {
                    slots: {
                        [(0, _utils.DEFAULT_SLOT)]: {},
                        chevron: {
                            ...expandButtonProps,
                            ref: expandButtonRef
                        },
                        drag: {
                            ...draggableItem?.dragButtonProps,
                            ref: dragButtonRef,
                            style: {
                                pointerEvents: 'none'
                            }
                        }
                    }
                }
            ],
            [
                TreeItemContentContext,
                {
                    ...renderPropValues
                }
            ],
            [
                (0, _selectionIndicator.SelectionIndicatorContext),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, children))));
});
const TreeLoadMoreItem = (0, _collectionBuilder.createLeafComponent)((0, _baseCollection.LoaderNode), function TreeLoadingSentinel(props, ref, item) {
    let { isVirtualized } = (0, _react.useContext)((0, _collection1.CollectionRendererContext));
    let state = (0, _react.useContext)(TreeStateContext);
    let { isLoading, onLoadMore, scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, _react.useRef)(null);
    let memoedLoadMoreProps = (0, _react.useMemo)(()=>({
            onLoadMore,
            // this collection will update anytime a row is expanded/collapsed becaused the flattenedRows will change.
            // This means onLoadMore will trigger but that might be ok cause the user should have logic to handle multiple loadMore calls
            collection: state?.collection,
            sentinelRef,
            scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, _useLoadMoreSentinel.useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    ref = (0, _useObjectRef.useObjectRef)(ref);
    let { rowProps, gridCellProps } = (0, _useTree.useTreeItem)({
        node: item
    }, state, ref);
    let level = rowProps['aria-level'] || 1;
    // For now don't include aria-posinset and aria-setsize on loader since they aren't keyboard focusable
    // Arguably shouldn't include them ever since it might be confusing to the user to include the loaders as part of the
    // item count
    let ariaProps = {
        role: 'row',
        'aria-level': rowProps['aria-level']
    };
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-TreeLoader',
        values: {
            level
        }
    });
    let style = {};
    if (isVirtualized) style = {
        display: 'contents'
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, _inertValue.inertValue)(true)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ref: ref,
        ...(0, _mergeProps.mergeProps)((0, _filterDOMProps.filterDOMProps)(props), ariaProps),
        ...renderProps,
        "data-level": level
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...gridCellProps,
        style: style
    }, renderProps.children)));
});
function TreeDropIndicatorWrapper(props, ref) {
    ref = (0, _useObjectRef.useObjectRef)(ref);
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _dragAndDrop.DragAndDropContext));
    let buttonRef = (0, _react.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps, isHidden, isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, buttonRef);
    if (isHidden) return null;
    let level = dropState && props.target.type === 'item' ? (dropState.collection.getItem(props.target.key)?.level || 0) + 1 : 1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TreeDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref,
        buttonRef: buttonRef,
        level: level
    });
}
function TreeDropIndicator(props, ref) {
    let { dropIndicatorProps, isDropTarget, buttonRef, level, ...otherProps } = props;
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    let renderProps = (0, _utils.useRenderProps)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        defaultStyle: {
            position: 'relative',
            // @ts-ignore
            '--tree-item-level': level
        },
        values: {
            isDropTarget
        }
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...renderProps,
        role: "row",
        "aria-level": level,
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: buttonRef
    }), renderProps.children));
}
const TreeDropIndicatorForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(TreeDropIndicator);
function RootDropIndicator() {
    let { dragAndDropHooks, dropState } = (0, _react.useContext)((0, _dragAndDrop.DragAndDropContext));
    let ref = (0, _react.useRef)(null);
    // oxlint-disable-next-line react/react-compiler
    let { dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps } = (0, _visuallyHidden.useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden'],
        style: {
            position: 'absolute'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "gridcell"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}
const TreeSection = /*#__PURE__*/ (0, _collectionBuilder.createBranchComponent)((0, _baseCollection.SectionNode), (props, ref, item)=>{
    let state = (0, _react.useContext)(TreeStateContext);
    let { CollectionBranch } = (0, _react.useContext)((0, _collection1.CollectionRendererContext));
    let headingRef = (0, _react.useRef)(null);
    ref = (0, _useObjectRef.useObjectRef)(ref);
    let { rowHeaderProps, rowProps, rowGroupProps } = (0, _useGridList.useGridListSection)({
        'aria-label': props['aria-label'] ?? undefined
    }, state, ref);
    let renderProps = (0, _utils.useRenderProps)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: 'react-aria-TreeSection',
        values: undefined
    });
    let DOMProps = (0, _filterDOMProps.filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.dom).div, {
        ...(0, _mergeProps.mergeProps)(DOMProps, renderProps, rowGroupProps),
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.Provider), {
        values: [
            [
                (0, _gridList.GridListHeaderContext),
                {
                    ...rowProps,
                    ref: headingRef
                }
            ],
            [
                (0, _gridList.GridListHeaderInnerContext),
                {
                    ...rowHeaderProps
                }
            ]
        ]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionBranch, {
        collection: state.collection,
        parent: item
    })));
});
const TreeHeader = (props)=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _gridList.GridListHeader), {
        className: "react-aria-TreeHeader",
        ...props
    }, props.children);
};
function areSetsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (let item of a){
        if (!b.has(item)) return false;
    }
    return true;
}

},{"react-aria/useTree":[["useTree","ggGEd"],["useTreeItem","alakO"]],"react-aria/private/collections/BaseCollection":"gZqwD","./Button":"9G5XO","./Checkbox":"9jC2J","./utils":"bA6Cz","react-aria/Collection":"3m036","react-aria/CollectionBuilder":"3m036","./Collection":"7QyMy","./DragAndDrop":"kft18","react-aria/filterDOMProps":"c0Owd","react-aria/FocusScope":"fNgMQ","./GridList":"8bLgh","react-aria/private/utils/inertValue":"8at61","react-aria/ListKeyboardDelegate":"29p4T","react-aria/private/utils/useLoadMoreSentinel":"2SbBS","react-aria/mergeProps":"1CzGd","react":"a1TxN","./SelectionIndicator":"dgQU7","./SharedElementTransition":"iVZnk","./TreeDropTargetDelegate":"bOwZQ","react-stately/useTreeState":"aFi9e","react-aria/private/collections/useCachedChildren":"j3DMA","react-aria/useCollator":"cpezb","react-stately/useControlledState":"iZt2P","react-aria/useFocusRing":"5qaYX","react-aria/useGridList":[["useGridListSection","lyxMI"],["useGridListSelectionCheckbox","c8jkL"]],"react-aria/useHover":"9zlAr","react-aria/useId":"de3v3","react-aria/I18nProvider":"l34Wn","react-aria/useObjectRef":"hJ6Rk","react-aria/VisuallyHidden":"4FxR8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ggGEd":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a single column treegrid component
 * with interactive children. A tree grid provides users with a way to navigate nested hierarchical
 * information.
 *
 * @param props - Props for the treegrid.
 * @param state - State for the treegrid, as returned by `useTreeState`.
 * @param ref - The ref attached to the treegrid element.
 */ parcelHelpers.export(exports, "useTree", ()=>useTree);
var _useGridList = require("../gridlist/useGridList");
function useTree(props, state, ref) {
    let { gridProps } = (0, _useGridList.useGridList)(props, state, ref);
    // oxlint-disable-next-line react/react-compiler
    gridProps.role = 'treegrid';
    return {
        gridProps
    };
}

},{"../gridlist/useGridList":"gOSBa","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3OmcS":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"alakO":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a tree grid list.
 *
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useTreeState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useTreeItem", ()=>useTreeItem);
var _useGridListItem = require("../gridlist/useGridListItem");
var _json = require("../../intl/tree/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _useLabels = require("../utils/useLabels");
var _useLocalizedStringFormatter = require("../i18n/useLocalizedStringFormatter");
function useTreeItem(props, state, ref) {
    let { node } = props;
    let gridListAria = (0, _useGridListItem.useGridListItem)(props, state, ref);
    let isExpanded = gridListAria.rowProps['aria-expanded'] === true;
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/tree');
    let labelProps = (0, _useLabels.useLabels)({
        'aria-label': isExpanded ? stringFormatter.format('collapse') : stringFormatter.format('expand'),
        'aria-labelledby': gridListAria.rowProps.id
    });
    let expandButtonProps = {
        onPress: ()=>{
            if (!gridListAria.isDisabled) {
                state.toggleKey(node.key);
                state.selectionManager.setFocused(true);
                state.selectionManager.setFocusedKey(node.key);
            }
        },
        excludeFromTabOrder: true,
        preventFocusOnPress: true,
        'data-react-aria-prevent-focus': true,
        ...labelProps
    };
    // TODO: should it return a state specifically for isExpanded? Or is aria attribute sufficient?
    return {
        ...gridListAria,
        expandButtonProps
    };
}

},{"../gridlist/useGridListItem":"gyqL4","../../intl/tree/*.json":"kwIMY","../utils/useLabels":"gVVPl","../i18n/useLocalizedStringFormatter":"4LM0k","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kwIMY":[function(require,module,exports,__globalThis) {
const _temp0 = require("a76e0664c3a63179");
const _temp1 = require("903f2574007191d7");
const _temp2 = require("302e8694c259cbe8");
const _temp3 = require("f0c1fba9dd795016");
const _temp4 = require("18b100f239b1cef4");
const _temp5 = require("2e43c7efc91dbd30");
const _temp6 = require("5090959480ca4197");
const _temp7 = require("885853bf8a5371f4");
const _temp8 = require("75887e0fc871e4d6");
const _temp9 = require("ace258d3348f47b6");
const _temp10 = require("7bdfe21020280e36");
const _temp11 = require("a2874e223b8b2f2b");
const _temp12 = require("365e8d316d30515");
const _temp13 = require("b83f54ea53ddbbfe");
const _temp14 = require("14a2e7ca49415602");
const _temp15 = require("71140eab94274d64");
const _temp16 = require("ca0697146255c546");
const _temp17 = require("28d2c3e081cbfb30");
const _temp18 = require("2b3ef325ad00cc06");
const _temp19 = require("5471e39ef05fa649");
const _temp20 = require("1fdbee8dcf0d631e");
const _temp21 = require("df0f0338741f899e");
const _temp22 = require("f5896ebf4778c8b2");
const _temp23 = require("f77ec3a4f6bef45f");
const _temp24 = require("4f74680a2f525196");
const _temp25 = require("4848d643197e3706");
const _temp26 = require("2319ebecdfff29b");
const _temp27 = require("ed4c7fc83c31c0a2");
const _temp28 = require("b5713e7df2459a55");
const _temp29 = require("9236360c9bc40ca4");
const _temp30 = require("563e7c71c2813f9a");
const _temp31 = require("2f56588aafc9a837");
const _temp32 = require("4a5ade96f8f202a3");
const _temp33 = require("e2587eada187faa3");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"a76e0664c3a63179":"gvRN3","903f2574007191d7":"jBcud","302e8694c259cbe8":"kS7s8","f0c1fba9dd795016":"gbKXz","18b100f239b1cef4":"jVOdW","2e43c7efc91dbd30":"83lq4","5090959480ca4197":"ivrm1","885853bf8a5371f4":"6fhSC","75887e0fc871e4d6":"bNbBs","ace258d3348f47b6":"itXe3","7bdfe21020280e36":"1blpU","a2874e223b8b2f2b":"29atM","365e8d316d30515":"dfepM","b83f54ea53ddbbfe":"anVS4","14a2e7ca49415602":"cdmeq","71140eab94274d64":"j195y","ca0697146255c546":"2pcrB","28d2c3e081cbfb30":"3f9w1","2b3ef325ad00cc06":"1jmZr","5471e39ef05fa649":"fQAeF","1fdbee8dcf0d631e":"kN9YR","df0f0338741f899e":"3umIf","f5896ebf4778c8b2":"7XYYA","f77ec3a4f6bef45f":"ieUcP","4f74680a2f525196":"bhobu","4848d643197e3706":"fKZGn","2319ebecdfff29b":"j2QUW","ed4c7fc83c31c0a2":"fO5dA","b5713e7df2459a55":"hgtH3","9236360c9bc40ca4":"lt2HT","563e7c71c2813f9a":"cuZhi","2f56588aafc9a837":"a9uuy","4a5ade96f8f202a3":"1FH74","e2587eada187faa3":"7GrXf"}],"gvRN3":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{637}\u{64A}`,
    "expand": `\u{62A}\u{645}\u{62F}\u{64A}\u{62F}`
};

},{}],"jBcud":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{421}\u{432}\u{438}\u{432}\u{430}\u{43D}\u{435}`,
    "expand": `\u{420}\u{430}\u{437}\u{448}\u{438}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435}`
};

},{}],"kS7s8":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Sbalit`,
    "expand": `Rozt\xe1hnout`
};

},{}],"gbKXz":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Skjul`,
    "expand": `Udvid`
};

},{}],"jVOdW":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Reduzieren`,
    "expand": `Erweitern`
};

},{}],"83lq4":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{3A3}\u{3CD}\u{3BC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "expand": `\u{391}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`
};

},{}],"ivrm1":[function(require,module,exports,__globalThis) {
module.exports = {
    "expand": `Expand`,
    "collapse": `Collapse`
};

},{}],"6fhSC":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Contraer`,
    "expand": `Expandir`
};

},{}],"bNbBs":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Ahenda`,
    "expand": `Laienda`
};

},{}],"itXe3":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Pienenn\xe4`,
    "expand": `Laajenna`
};

},{}],"1blpU":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `R\xe9duire`,
    "expand": `D\xe9velopper`
};

},{}],"29atM":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{5DB}\u{5D5}\u{5D5}\u{5E5}`,
    "expand": `\u{5D4}\u{5E8}\u{5D7}\u{5D1}`
};

},{}],"dfepM":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Sa\u{17E}mi`,
    "expand": `Pro\u{161}iri`
};

},{}],"anVS4":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\xd6sszecsuk\xe1s`,
    "expand": `Kibont\xe1s`
};

},{}],"cdmeq":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Comprimi`,
    "expand": `Espandi`
};

},{}],"j195y":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{6298}\u{308A}\u{305F}\u{305F}\u{3080}`,
    "expand": `\u{5C55}\u{958B}`
};

},{}],"2pcrB":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{C811}\u{AE30}`,
    "expand": `\u{D3BC}\u{CE58}\u{AE30}`
};

},{}],"3f9w1":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Sutraukti`,
    "expand": `I\u{161}skleisti`
};

},{}],"1jmZr":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Sak\u{13C}aut`,
    "expand": `Izv\u{113}rst`
};

},{}],"fQAeF":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Skjul`,
    "expand": `Utvid`
};

},{}],"kN9YR":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Samenvouwen`,
    "expand": `Uitvouwen`
};

},{}],"3umIf":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Zwi\u{144}`,
    "expand": `Rozwi\u{144}`
};

},{}],"7XYYA":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Recolher`,
    "expand": `Expandir`
};

},{}],"ieUcP":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Colapsar`,
    "expand": `Expandir`
};

},{}],"bhobu":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Restr\xe2nge\u{21B}i`,
    "expand": `Extinde\u{21B}i`
};

},{}],"fKZGn":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{421}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "expand": `\u{420}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`
};

},{}],"j2QUW":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Zbali\u{165}`,
    "expand": `Rozbali\u{165}`
};

},{}],"fO5dA":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Strni`,
    "expand": `Raz\u{161}iri`
};

},{}],"hgtH3":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": ` Skupi`,
    "expand": `Pro\u{161}iri`
};

},{}],"lt2HT":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `D\xf6lj`,
    "expand": `Expandera`
};

},{}],"cuZhi":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `Daralt`,
    "expand": `Geni\u{15F}let`
};

},{}],"a9uuy":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "expand": `\u{420}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`
};

},{}],"1FH74":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{6298}\u{53E0}`,
    "expand": `\u{6269}\u{5C55}`
};

},{}],"7GrXf":[function(require,module,exports,__globalThis) {
module.exports = {
    "collapse": `\u{6536}\u{5408}`,
    "expand": `\u{5C55}\u{958B}`
};

},{}],"kr3Zp":[function() {},{}],"j0bDS":[function() {},{}],"em0fw":[function() {},{}],"dR1mU":[function() {},{}],"2SxIO":[function() {},{}],"aSDjJ":[function() {},{}],"8j4BZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptimisticToc", ()=>OptimisticToc);
parcelHelpers.export(exports, "OptimisticMobileToc", ()=>OptimisticMobileToc);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _markdownMenu = require("./MarkdownMenu");
var _nav = require("./Nav");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _scrollableToc = require("./ScrollableToc");
var _router = require("./Router");
'use client';
function anchorId(children) {
    return children.replace(/\s/g, '-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
}
let tocLinkTextStyle = " -nTSCV-LTAEPe171 __ZLTAEPe171 Na171";
function Toc({ toc, isNested = false }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.OnPageNav), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNav), {
            isNested: isNested,
            children: toc.map((c, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _nav.SideNavItem), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNavLink), {
                            href: '#' + anchorId(c.title),
                            title: c.title,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: tocLinkTextStyle,
                                children: c.title
                            })
                        }),
                        c.children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toc, {
                            toc: c.children,
                            isNested: true
                        })
                    ]
                }, i))
        })
    });
}
function renderMobileToc(toc, seen = new Map()) {
    return toc.map((c)=>{
        let href = c.level === 1 ? '#top' : '#' + anchorId(c.title);
        if (seen.has(href)) {
            seen.set(href, seen.get(href) + 1);
            href += '-' + seen.get(href);
        } else seen.set(href, 1);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.PickerItem), {
                    id: href,
                    href: href,
                    children: c.title
                }),
                c.children.length > 0 && renderMobileToc(c.children, seen)
            ]
        }, href);
    });
}
function OptimisticToc() {
    let { currentPage } = (0, _router.useRouter)();
    let section = currentPage.exports?.section;
    let hasToC = (!currentPage.exports?.hideNav || section === 'Blog' || section === 'Releases') && currentPage.tableOfContents?.[0]?.children && currentPage.tableOfContents?.[0]?.children?.length > 0;
    if (!hasToC) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("aside", {
        className: " _Pe171 Wr171 Tk171 GaT6Oqc171 _oa171 ZjHC1be171 _va171 sk171 spd171 _ta171",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk171 ucJ9TBTb171 ud3Euai171 uea171 ugb171 uhd171 uje171 u2NhKxcl171 uic171 -_6BNtrc-d171 vFHT6Dd171 xd171 _xa171 xX0cczbc171 _xX0cczba171 xfd171 _xfa171 xfX0cczbc171 _xfX0cczba171 _Fd171 _FnuYUweb171 po171 M4dY0ec171 Se171 Re171 sd171 eb171 GR3ltQc171 _va171",
                children: "On this page"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _scrollableToc.ScrollableToc), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toc, {
                        toc: currentPage.tableOfContents?.[0]?.children ?? []
                    }, currentPage.url),
                    currentPage.exports?.relatedPages && /*#__PURE__*/ (0, _jsxRuntime.jsx)(RelatedPages, {
                        pages: currentPage.exports.relatedPages
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " _va171",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                        size: "S",
                        styles: " Ji9a9Xd171 Gi9a9Xd171"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownMenu.MarkdownMenu), {
                        name: currentPage.name,
                        url: currentPage.url
                    })
                ]
            })
        ]
    });
}
function isExternalUrl(url) {
    return url.startsWith('http://') || url.startsWith('https://');
}
function RelatedPages({ pages }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " Th171",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " uk171 ucJ9TBTb171 ud3Euai171 uea171 ugb171 uhd171 uje171 u2NhKxcl171 uic171 -_6BNtrc-d171 vFHT6Dd171 xd171 _xa171 xX0cczbc171 _xX0cczba171 xfd171 _xfa171 xfX0cczbc171 _xfX0cczba171 _Fd171 _FnuYUweb171 po171 M4dY0ec171 Se171 Re171 sd171 eb171",
                children: "Related pages"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.OnPageNav), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNav), {
                    children: pages.map((page, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNavItem), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.SideNavLink), {
                                href: page.url,
                                isExternal: isExternalUrl(page.url),
                                children: page.title
                            })
                        }, i))
                })
            })
        ]
    });
}
function OptimisticMobileToc() {
    let { currentPage } = (0, _router.useRouter)();
    if ((currentPage.tableOfContents?.[0]?.children?.length ?? 0) <= 1) return null;
    let withRelatedPages = currentPage.exports?.relatedPages ? [
        ...currentPage.tableOfContents ?? [],
        {
            level: 2,
            title: 'Related pages',
            children: []
        }
    ] : currentPage.tableOfContents;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nav.MobileOnPageNav), {
        children: renderMobileToc(withRelatedPages)
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["Divider","kGk2u"],["PickerItem","akpch"]],"./MarkdownMenu":"8BIYE","./Nav":"iFN5Z","react":"a1TxN","./ScrollableToc":"iKE7T","./Router":"jI9xq","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4oKuc":[function(require,module,exports,__globalThis) {
var _serverEdge = require("react-server-dom-parcel/server.edge");
exports.__esModule = true;

},{"react-server-dom-parcel/server.edge":"74WJu"}],"74WJu":[function(require,module,exports,__globalThis) {
'use strict';
var s;
s = require("8884f512c685da86");
exports.renderToReadableStream = s.renderToReadableStream;
exports.decodeReply = s.decodeReply;
exports.decodeReplyFromAsyncIterable = s.decodeReplyFromAsyncIterable;
exports.decodeAction = s.decodeAction;
exports.decodeFormState = s.decodeFormState;
exports.createClientReference = s.createClientReference;
exports.registerServerReference = s.registerServerReference;
exports.createTemporaryReferenceSet = s.createTemporaryReferenceSet;
exports.registerServerActions = s.registerServerActions;
exports.loadServerAction = s.loadServerAction;

},{"8884f512c685da86":"iGhi4"}],"iGhi4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-server-dom-parcel-server.edge.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactDOM = require("2381f0f3ff03ff95"), React = require("6db66a729b66b575"), ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function resolveServerReference(bundlerConfig, ref) {
    var idx = ref.lastIndexOf("#"), id = ref.slice(0, idx);
    idx = ref.slice(idx + 1);
    bundlerConfig = bundlerConfig[id];
    if (!bundlerConfig) throw Error("Invalid server action: " + ref);
    return [
        id,
        idx,
        bundlerConfig
    ];
}
function preloadModule$1(metadata) {
    metadata[3] && module.bundle.extendImportMap(metadata[3]);
    return 0 === metadata[2].length ? null : Promise.all(metadata[2].map(function(url) {
        return module.bundle.load(url);
    }));
}
function requireModule(metadata) {
    return module.bundle.root(metadata[0])[metadata[1]];
}
var REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.postpone");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ASYNC_ITERATOR = Symbol.asyncIterator;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var LocalPromise = Promise, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    LocalPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
}, currentView = null, writtenBytes = 0;
function writeChunkAndReturn(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = new Uint8Array(2048), writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = currentView.length - writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue(currentView) : (currentView.set(chunk.subarray(0, allowableBytes), writtenBytes), destination.enqueue(currentView), chunk = chunk.subarray(allowableBytes)), currentView = new Uint8Array(2048), writtenBytes = 0);
            currentView.set(chunk, writtenBytes);
            writtenBytes += chunk.byteLength;
        }
    }
    return !0;
}
var textEncoder = new TextEncoder();
function stringToChunk(content) {
    return textEncoder.encode(content);
}
function byteLengthOfChunk(chunk) {
    return chunk.byteLength;
}
function closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var CLIENT_REFERENCE_TAG$1 = Symbol.for("react.client.reference"), SERVER_REFERENCE_TAG = Symbol.for("react.server.reference"), FunctionBind = Function.prototype.bind, ArraySlice = Array.prototype.slice;
function bind() {
    var newFn = FunctionBind.apply(this, arguments);
    if (this.$$typeof === SERVER_REFERENCE_TAG) {
        var args = ArraySlice.call(arguments, 1), $$typeof = {
            value: SERVER_REFERENCE_TAG
        }, $$id = {
            value: this.$$id
        };
        args = {
            value: this.$$bound ? this.$$bound.concat(args) : args
        };
        return Object.defineProperties(newFn, {
            $$typeof: $$typeof,
            $$id: $$id,
            $$bound: args,
            bind: {
                value: bind,
                configurable: !0
            }
        });
    }
    return newFn;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: previousDispatcher.f,
    r: previousDispatcher.r,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function prefetchDNS(href) {
    if ("string" === typeof href && href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "D|" + href;
            hints.has(key) || (hints.add(key), emitHint(request, "D", href));
        } else previousDispatcher.D(href);
    }
}
function preconnect(href, crossOrigin) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "C|" + (null == crossOrigin ? "null" : crossOrigin) + "|" + href;
            hints.has(key) || (hints.add(key), "string" === typeof crossOrigin ? emitHint(request, "C", [
                href,
                crossOrigin
            ]) : emitHint(request, "C", href));
        } else previousDispatcher.C(href, crossOrigin);
    }
}
function preload(href, as, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "L";
            if ("image" === as && options) {
                var imageSrcSet = options.imageSrcSet, imageSizes = options.imageSizes, uniquePart = "";
                "string" === typeof imageSrcSet && "" !== imageSrcSet ? (uniquePart += "[" + imageSrcSet + "]", "string" === typeof imageSizes && (uniquePart += "[" + imageSizes + "]")) : uniquePart += "[][]" + href;
                key += "[image]" + uniquePart;
            } else key += "[" + as + "]" + href;
            hints.has(key) || (hints.add(key), (options = trimOptions(options)) ? emitHint(request, "L", [
                href,
                as,
                options
            ]) : emitHint(request, "L", [
                href,
                as
            ]));
        } else previousDispatcher.L(href, as, options);
    }
}
function preloadModule(href, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "m|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "m", [
                href,
                options
            ]) : emitHint(request, "m", href);
        }
        previousDispatcher.m(href, options);
    }
}
function preinitStyle(href, precedence, options) {
    if ("string" === typeof href) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "S|" + href;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "S", [
                href,
                "string" === typeof precedence ? precedence : 0,
                options
            ]) : "string" === typeof precedence ? emitHint(request, "S", [
                href,
                precedence
            ]) : emitHint(request, "S", href);
        }
        previousDispatcher.S(href, precedence, options);
    }
}
function preinitScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "X|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "X", [
                src,
                options
            ]) : emitHint(request, "X", src);
        }
        previousDispatcher.X(src, options);
    }
}
function preinitModuleScript(src, options) {
    if ("string" === typeof src) {
        var request = resolveRequest();
        if (request) {
            var hints = request.hints, key = "M|" + src;
            if (hints.has(key)) return;
            hints.add(key);
            return (options = trimOptions(options)) ? emitHint(request, "M", [
                src,
                options
            ]) : emitHint(request, "M", src);
        }
        previousDispatcher.M(src, options);
    }
}
function trimOptions(options) {
    if (null == options) return null;
    var hasProperties = !1, trimmed = {}, key;
    for(key in options)null != options[key] && (hasProperties = !0, trimmed[key] = options[key]);
    return hasProperties ? trimmed : null;
}
var supportsRequestStorage = "function" === typeof AsyncLocalStorage, requestStorage = supportsRequestStorage ? new AsyncLocalStorage() : null, TEMPORARY_REFERENCE_TAG = Symbol.for("react.temporary.reference"), proxyHandlers = {
    get: function(target, name) {
        switch(name){
            case "$$typeof":
                return target.$$typeof;
            case "name":
                return;
            case "displayName":
                return;
            case "defaultProps":
                return;
            case "_debugInfo":
                return;
            case "toJSON":
                return;
            case Symbol.toPrimitive:
                return Object.prototype[Symbol.toPrimitive];
            case Symbol.toStringTag:
                return Object.prototype[Symbol.toStringTag];
            case "Provider":
                throw Error("Cannot render a Client Context Provider on the Server. Instead, you can export a Client Component wrapper that itself renders a Client Context Provider.");
        }
        throw Error("Cannot access " + String(name) + " on the server. You cannot dot into a temporary client reference from a server component. You can only pass the value through to the client.");
    },
    set: function() {
        throw Error("Cannot assign to a temporary client reference from a server module.");
    }
};
function createTemporaryReference(temporaryReferences, id) {
    var reference = Object.defineProperties(function() {
        throw Error("Attempted to call a temporary Client Reference from the server but it is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component.");
    }, {
        $$typeof: {
            value: TEMPORARY_REFERENCE_TAG
        }
    });
    reference = new Proxy(reference, proxyHandlers);
    temporaryReferences.set(reference, id);
    return reference;
}
function noop() {}
var SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`.");
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop, noop), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then(noop, noop) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
var currentRequest$1 = null, thenableIndexCounter = 0, thenableState = null;
function getThenableStateAfterSuspending() {
    var state = thenableState || [];
    thenableState = null;
    return state;
}
var HooksDispatcher = {
    readContext: unsupportedContext,
    use: use,
    useCallback: function(callback) {
        return callback;
    },
    useContext: unsupportedContext,
    useEffect: unsupportedHook,
    useImperativeHandle: unsupportedHook,
    useLayoutEffect: unsupportedHook,
    useInsertionEffect: unsupportedHook,
    useMemo: function(nextCreate) {
        return nextCreate();
    },
    useReducer: unsupportedHook,
    useRef: unsupportedHook,
    useState: unsupportedHook,
    useDebugValue: function() {},
    useDeferredValue: unsupportedHook,
    useTransition: unsupportedHook,
    useSyncExternalStore: unsupportedHook,
    useId: useId,
    useHostTransitionStatus: unsupportedHook,
    useFormState: unsupportedHook,
    useActionState: unsupportedHook,
    useOptimistic: unsupportedHook,
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return unsupportedRefresh;
    }
};
function unsupportedHook() {
    throw Error("This Hook is not supported in Server Components.");
}
function unsupportedRefresh() {
    throw Error("Refreshing the cache is not supported in Server Components.");
}
function unsupportedContext() {
    throw Error("Cannot read a Client Context from a Server Component.");
}
function useId() {
    if (null === currentRequest$1) throw Error("useId can only be used while React is rendering");
    var id = currentRequest$1.identifierCount++;
    return "_" + currentRequest$1.identifierPrefix + "S_" + id.toString(32) + "_";
}
function use(usable) {
    if (null !== usable && "object" === typeof usable || "function" === typeof usable) {
        if ("function" === typeof usable.then) {
            var index = thenableIndexCounter;
            thenableIndexCounter += 1;
            null === thenableState && (thenableState = []);
            return trackUsedThenable(thenableState, usable, index);
        }
        usable.$$typeof === REACT_CONTEXT_TYPE && unsupportedContext();
    }
    if (usable.$$typeof === CLIENT_REFERENCE_TAG$1) {
        if (null != usable.value && usable.value.$$typeof === REACT_CONTEXT_TYPE) throw Error("Cannot read a Client Context from a Server Component.");
        throw Error("Cannot use() an already resolved Client Reference.");
    }
    throw Error("An unsupported type was passed to use(): " + String(usable));
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var JSCompiler_inline_result = (JSCompiler_inline_result = resolveRequest()) ? JSCompiler_inline_result.cache : new Map();
        var entry = JSCompiler_inline_result.get(resourceType);
        void 0 === entry && (entry = resourceType(), JSCompiler_inline_result.set(resourceType, entry));
        return entry;
    },
    cacheSignal: function() {
        var request = resolveRequest();
        return request ? request.cacheController.signal : null;
    }
}, ReactSharedInternalsServer = React.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
if (!ReactSharedInternalsServer) throw Error('The "react" package in this environment is not configured correctly. The "react-server" condition must be enabled in any environment that runs React Server Components.');
var isArrayImpl = Array.isArray, getPrototypeOf = Object.getPrototypeOf;
function objectName(object) {
    object = Object.prototype.toString.call(object);
    return object.slice(8, object.length - 1);
}
function describeValueForErrorMessage(value) {
    switch(typeof value){
        case "string":
            return JSON.stringify(10 >= value.length ? value : value.slice(0, 10) + "...");
        case "object":
            if (isArrayImpl(value)) return "[...]";
            if (null !== value && value.$$typeof === CLIENT_REFERENCE_TAG) return "client";
            value = objectName(value);
            return "Object" === value ? "{...}" : value;
        case "function":
            return value.$$typeof === CLIENT_REFERENCE_TAG ? "client" : (value = value.displayName || value.name) ? "function " + value : "function";
        default:
            return String(value);
    }
}
function describeElementType(type) {
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_FORWARD_REF_TYPE:
            return describeElementType(type.render);
        case REACT_MEMO_TYPE:
            return describeElementType(type.type);
        case REACT_LAZY_TYPE:
            var payload = type._payload;
            type = type._init;
            try {
                return describeElementType(type(payload));
            } catch (x) {}
    }
    return "";
}
var CLIENT_REFERENCE_TAG = Symbol.for("react.client.reference");
function describeObjectForErrorMessage(objectOrArray, expandedName) {
    var objKind = objectName(objectOrArray);
    if ("Object" !== objKind && "Array" !== objKind) return objKind;
    objKind = -1;
    var length = 0;
    if (isArrayImpl(objectOrArray)) {
        var str = "[";
        for(var i = 0; i < objectOrArray.length; i++){
            0 < i && (str += ", ");
            var value = objectOrArray[i];
            value = "object" === typeof value && null !== value ? describeObjectForErrorMessage(value) : describeValueForErrorMessage(value);
            "" + i === expandedName ? (objKind = str.length, length = value.length, str += value) : str = 10 > value.length && 40 > str.length + value.length ? str + value : str + "...";
        }
        str += "]";
    } else if (objectOrArray.$$typeof === REACT_ELEMENT_TYPE) str = "<" + describeElementType(objectOrArray.type) + "/>";
    else {
        if (objectOrArray.$$typeof === CLIENT_REFERENCE_TAG) return "client";
        str = "{";
        i = Object.keys(objectOrArray);
        for(value = 0; value < i.length; value++){
            0 < value && (str += ", ");
            var name = i[value], encodedKey = JSON.stringify(name);
            str += ('"' + name + '"' === encodedKey ? name : encodedKey) + ": ";
            encodedKey = objectOrArray[name];
            encodedKey = "object" === typeof encodedKey && null !== encodedKey ? describeObjectForErrorMessage(encodedKey) : describeValueForErrorMessage(encodedKey);
            name === expandedName ? (objKind = str.length, length = encodedKey.length, str += encodedKey) : str = 10 > encodedKey.length && 40 > str.length + encodedKey.length ? str + encodedKey : str + "...";
        }
        str += "}";
    }
    return void 0 === expandedName ? str : -1 < objKind && 0 < length ? (objectOrArray = " ".repeat(objKind) + "^".repeat(length), "\n  " + str + "\n  " + objectOrArray) : "\n  " + str;
}
var hasOwnProperty = Object.prototype.hasOwnProperty, ObjectPrototype = Object.prototype, stringify = JSON.stringify;
function defaultErrorHandler(error) {
    console.error(error);
}
function RequestInstance(type, model, bundlerConfig, onError, onPostpone, onAllReady, onFatalError, identifierPrefix, temporaryReferences) {
    if (null !== ReactSharedInternalsServer.A && ReactSharedInternalsServer.A !== DefaultAsyncDispatcher) throw Error("Currently React only supports one RSC renderer at a time.");
    ReactSharedInternalsServer.A = DefaultAsyncDispatcher;
    var abortSet = new Set(), pingedTasks = [], hints = new Set();
    this.type = type;
    this.status = 10;
    this.flushScheduled = !1;
    this.destination = this.fatalError = null;
    this.bundlerConfig = bundlerConfig;
    this.cache = new Map();
    this.cacheController = new AbortController();
    this.pendingChunks = this.nextChunkId = 0;
    this.hints = hints;
    this.abortableTasks = abortSet;
    this.pingedTasks = pingedTasks;
    this.completedImportChunks = [];
    this.completedHintChunks = [];
    this.completedRegularChunks = [];
    this.completedErrorChunks = [];
    this.writtenSymbols = new Map();
    this.writtenClientReferences = new Map();
    this.writtenServerReferences = new Map();
    this.writtenObjects = new WeakMap();
    this.temporaryReferences = temporaryReferences;
    this.identifierPrefix = identifierPrefix || "";
    this.identifierCount = 1;
    this.taintCleanupQueue = [];
    this.onError = void 0 === onError ? defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? noop : onPostpone;
    this.onAllReady = onAllReady;
    this.onFatalError = onFatalError;
    type = createTask(this, model, null, !1, abortSet);
    pingedTasks.push(type);
}
var currentRequest = null;
function resolveRequest() {
    if (currentRequest) return currentRequest;
    if (supportsRequestStorage) {
        var store = requestStorage.getStore();
        if (store) return store;
    }
    return null;
}
function serializeThenable(request, task, thenable) {
    var newTask = createTask(request, thenable, task.keyPath, task.implicitSlot, request.abortableTasks);
    switch(thenable.status){
        case "fulfilled":
            return newTask.model = thenable.value, pingTask(request, newTask), newTask.id;
        case "rejected":
            return erroredTask(request, newTask, thenable.reason), newTask.id;
        default:
            if (12 === request.status) return request.abortableTasks.delete(newTask), task = request.fatalError, abortTask(newTask), finishAbortedTask(newTask, request, task), newTask.id;
            "string" !== typeof thenable.status && (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            }));
    }
    thenable.then(function(value) {
        newTask.model = value;
        pingTask(request, newTask);
    }, function(reason) {
        0 === newTask.status && (erroredTask(request, newTask, reason), enqueueFlush(request));
    });
    return newTask.id;
}
function serializeReadableStream(request, task, stream) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) streamTask.status = 1, entry = streamTask.id.toString(16) + ":C\n", request.completedRegularChunks.push(stringToChunk(entry)), request.abortableTasks.delete(streamTask), request.cacheController.signal.removeEventListener("abort", abortStream), enqueueFlush(request), callOnAllReadyIfReady(request);
            else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), reader.read().then(progress, error);
            } catch (x$8) {
                error(x$8);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortStream), erroredTask(request, streamTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortStream() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortStream);
            signal = signal.reason;
            erroredTask(request, streamTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var supportsBYOB = stream.supportsBYOB;
    if (void 0 === supportsBYOB) try {
        stream.getReader({
            mode: "byob"
        }).releaseLock(), supportsBYOB = !0;
    } catch (x) {
        supportsBYOB = !1;
    }
    var reader = stream.getReader(), streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (supportsBYOB ? "r" : "R") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortStream);
    reader.read().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function serializeAsyncIterable(request, task, iterable, iterator) {
    function progress(entry) {
        if (0 === streamTask.status) {
            if (entry.done) {
                streamTask.status = 1;
                if (void 0 === entry.value) var endStreamRow = streamTask.id.toString(16) + ":C\n";
                else try {
                    var chunkId = outlineModel(request, entry.value);
                    endStreamRow = streamTask.id.toString(16) + ":C" + stringify(serializeByValueID(chunkId)) + "\n";
                } catch (x) {
                    error(x);
                    return;
                }
                request.completedRegularChunks.push(stringToChunk(endStreamRow));
                request.abortableTasks.delete(streamTask);
                request.cacheController.signal.removeEventListener("abort", abortIterable);
                enqueueFlush(request);
                callOnAllReadyIfReady(request);
            } else try {
                streamTask.model = entry.value, request.pendingChunks++, tryStreamTask(request, streamTask), enqueueFlush(request), iterator.next().then(progress, error);
            } catch (x$9) {
                error(x$9);
            }
        }
    }
    function error(reason) {
        0 === streamTask.status && (request.cacheController.signal.removeEventListener("abort", abortIterable), erroredTask(request, streamTask, reason), enqueueFlush(request), "function" === typeof iterator.throw && iterator.throw(reason).then(error, error));
    }
    function abortIterable() {
        if (0 === streamTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortIterable);
            var reason = signal.reason;
            erroredTask(request, streamTask, signal.reason);
            enqueueFlush(request);
            "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
        }
    }
    iterable = iterable === iterator;
    var streamTask = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    request.pendingChunks++;
    task = streamTask.id.toString(16) + ":" + (iterable ? "x" : "X") + "\n";
    request.completedRegularChunks.push(stringToChunk(task));
    request.cacheController.signal.addEventListener("abort", abortIterable);
    iterator.next().then(progress, error);
    return serializeByValueID(streamTask.id);
}
function emitHint(request, code, model) {
    model = stringify(model);
    code = stringToChunk(":H" + code + model + "\n");
    request.completedHintChunks.push(code);
    enqueueFlush(request);
}
function readThenable(thenable) {
    if ("fulfilled" === thenable.status) return thenable.value;
    if ("rejected" === thenable.status) throw thenable.reason;
    throw thenable;
}
function createLazyWrapperAroundWakeable(request, task, wakeable) {
    switch(wakeable.status){
        case "fulfilled":
            return wakeable.value;
        case "rejected":
            break;
        default:
            "string" !== typeof wakeable.status && (wakeable.status = "pending", wakeable.then(function(fulfilledValue) {
                "pending" === wakeable.status && (wakeable.status = "fulfilled", wakeable.value = fulfilledValue);
            }, function(error) {
                "pending" === wakeable.status && (wakeable.status = "rejected", wakeable.reason = error);
            }));
    }
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: wakeable,
        _init: readThenable
    };
}
function voidHandler() {}
function processServerComponentReturnValue(request, task, Component, result) {
    if ("object" !== typeof result || null === result || result.$$typeof === CLIENT_REFERENCE_TAG$1) return result;
    if ("function" === typeof result.then) return createLazyWrapperAroundWakeable(request, task, result);
    var iteratorFn = getIteratorFn(result);
    return iteratorFn ? (request = {}, request[Symbol.iterator] = function() {
        return iteratorFn.call(result);
    }, request) : "function" !== typeof result[ASYNC_ITERATOR] || "function" === typeof ReadableStream && result instanceof ReadableStream ? result : (request = {}, request[ASYNC_ITERATOR] = function() {
        return result[ASYNC_ITERATOR]();
    }, request);
}
function renderFunctionComponent(request, task, key, Component, props) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    thenableIndexCounter = 0;
    thenableState = prevThenableState;
    props = Component(props, void 0);
    if (12 === request.status) throw "object" === typeof props && null !== props && "function" === typeof props.then && props.$$typeof !== CLIENT_REFERENCE_TAG$1 && props.then(voidHandler, voidHandler), null;
    props = processServerComponentReturnValue(request, task, Component, props);
    Component = task.keyPath;
    prevThenableState = task.implicitSlot;
    null !== key ? task.keyPath = null === Component ? key : Component + "," + key : null === Component && (task.implicitSlot = !0);
    request = renderModelDestructive(request, task, emptyRoot, "", props);
    task.keyPath = Component;
    task.implicitSlot = prevThenableState;
    return request;
}
function renderFragment(request, task, children) {
    return null !== task.keyPath ? (request = [
        REACT_ELEMENT_TYPE,
        REACT_FRAGMENT_TYPE,
        task.keyPath,
        {
            children: children
        }
    ], task.implicitSlot ? [
        request
    ] : request) : children;
}
var serializedSize = 0;
function deferTask(request, task) {
    task = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
    pingTask(request, task);
    return "$L" + task.id.toString(16);
}
function renderElement(request, task, type, key, ref, props) {
    if (null !== ref && void 0 !== ref) throw Error("Refs cannot be used in Server Components, nor passed to Client Components.");
    if ("function" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1 && type.$$typeof !== TEMPORARY_REFERENCE_TAG) return renderFunctionComponent(request, task, key, type, props);
    if (type === REACT_FRAGMENT_TYPE && null === key) return type = task.implicitSlot, null === task.keyPath && (task.implicitSlot = !0), props = renderModelDestructive(request, task, emptyRoot, "", props.children), task.implicitSlot = type, props;
    if (null != type && "object" === typeof type && type.$$typeof !== CLIENT_REFERENCE_TAG$1) switch(type.$$typeof){
        case REACT_LAZY_TYPE:
            var init = type._init;
            type = init(type._payload);
            if (12 === request.status) throw null;
            return renderElement(request, task, type, key, ref, props);
        case REACT_FORWARD_REF_TYPE:
            return renderFunctionComponent(request, task, key, type.render, props);
        case REACT_MEMO_TYPE:
            return renderElement(request, task, type.type, key, ref, props);
    }
    request = key;
    key = task.keyPath;
    null === request ? request = key : null !== key && (request = key + "," + request);
    props = [
        REACT_ELEMENT_TYPE,
        type,
        request,
        props
    ];
    task = task.implicitSlot && null !== request ? [
        props
    ] : props;
    return task;
}
function pingTask(request, task) {
    var pingedTasks = request.pingedTasks;
    pingedTasks.push(task);
    1 === pingedTasks.length && (request.flushScheduled = null !== request.destination, 21 === request.type || 10 === request.status ? scheduleMicrotask(function() {
        return performWork(request);
    }) : setTimeout(function() {
        return performWork(request);
    }, 0));
}
function createTask(request, model, keyPath, implicitSlot, abortSet) {
    request.pendingChunks++;
    var id = request.nextChunkId++;
    "object" !== typeof model || null === model || null !== keyPath || implicitSlot || request.writtenObjects.set(model, serializeByValueID(id));
    var task = {
        id: id,
        status: 0,
        model: model,
        keyPath: keyPath,
        implicitSlot: implicitSlot,
        ping: function() {
            return pingTask(request, task);
        },
        toJSON: function(parentPropertyName, value) {
            serializedSize += parentPropertyName.length;
            var prevKeyPath = task.keyPath, prevImplicitSlot = task.implicitSlot;
            try {
                var JSCompiler_inline_result = renderModelDestructive(request, task, this, parentPropertyName, value);
            } catch (thrownValue) {
                if (parentPropertyName = task.model, parentPropertyName = "object" === typeof parentPropertyName && null !== parentPropertyName && (parentPropertyName.$$typeof === REACT_ELEMENT_TYPE || parentPropertyName.$$typeof === REACT_LAZY_TYPE), 12 === request.status) task.status = 3, prevKeyPath = request.fatalError, JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
                else if (value = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue, "object" === typeof value && null !== value && "function" === typeof value.then) {
                    JSCompiler_inline_result = createTask(request, task.model, task.keyPath, task.implicitSlot, request.abortableTasks);
                    var ping = JSCompiler_inline_result.ping;
                    value.then(ping, ping);
                    JSCompiler_inline_result.thenableState = getThenableStateAfterSuspending();
                    task.keyPath = prevKeyPath;
                    task.implicitSlot = prevImplicitSlot;
                    JSCompiler_inline_result = parentPropertyName ? "$L" + JSCompiler_inline_result.id.toString(16) : serializeByValueID(JSCompiler_inline_result.id);
                } else task.keyPath = prevKeyPath, task.implicitSlot = prevImplicitSlot, request.pendingChunks++, prevKeyPath = request.nextChunkId++, prevImplicitSlot = logRecoverableError(request, value, task), emitErrorChunk(request, prevKeyPath, prevImplicitSlot), JSCompiler_inline_result = parentPropertyName ? "$L" + prevKeyPath.toString(16) : serializeByValueID(prevKeyPath);
            }
            return JSCompiler_inline_result;
        },
        thenableState: null
    };
    abortSet.add(task);
    return task;
}
function serializeByValueID(id) {
    return "$" + id.toString(16);
}
function encodeReferenceChunk(request, id, reference) {
    request = stringify(reference);
    id = id.toString(16) + ":" + request + "\n";
    return stringToChunk(id);
}
function serializeClientReference(request, parent, parentPropertyName, clientReference) {
    var clientReferenceKey = clientReference.$$id + "#" + clientReference.$$name, writtenClientReferences = request.writtenClientReferences, existingId = writtenClientReferences.get(clientReferenceKey);
    if (void 0 !== existingId) return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + existingId.toString(16) : serializeByValueID(existingId);
    try {
        var JSCompiler_inline_result = clientReference.$$importMap ? [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles,
            clientReference.$$importMap
        ] : [
            clientReference.$$id,
            clientReference.$$name,
            clientReference.$$bundles
        ];
        request.pendingChunks++;
        var importId = request.nextChunkId++, json = stringify(JSCompiler_inline_result), row = importId.toString(16) + ":I" + json + "\n", processedChunk = stringToChunk(row);
        request.completedImportChunks.push(processedChunk);
        writtenClientReferences.set(clientReferenceKey, importId);
        return parent[0] === REACT_ELEMENT_TYPE && "1" === parentPropertyName ? "$L" + importId.toString(16) : serializeByValueID(importId);
    } catch (x) {
        return request.pendingChunks++, parent = request.nextChunkId++, parentPropertyName = logRecoverableError(request, x, null), emitErrorChunk(request, parent, parentPropertyName), serializeByValueID(parent);
    }
}
function outlineModel(request, value) {
    value = createTask(request, value, null, !1, request.abortableTasks);
    retryTask(request, value);
    return value.id;
}
function serializeTypedArray(request, tag, typedArray) {
    request.pendingChunks++;
    var bufferId = request.nextChunkId++;
    emitTypedArrayChunk(request, bufferId, tag, typedArray, !1);
    return serializeByValueID(bufferId);
}
function serializeBlob(request, blob) {
    function progress(entry) {
        if (0 === newTask.status) {
            if (entry.done) request.cacheController.signal.removeEventListener("abort", abortBlob), pingTask(request, newTask);
            else return model.push(entry.value), reader.read().then(progress).catch(error);
        }
    }
    function error(reason) {
        0 === newTask.status && (request.cacheController.signal.removeEventListener("abort", abortBlob), erroredTask(request, newTask, reason), enqueueFlush(request), reader.cancel(reason).then(error, error));
    }
    function abortBlob() {
        if (0 === newTask.status) {
            var signal = request.cacheController.signal;
            signal.removeEventListener("abort", abortBlob);
            signal = signal.reason;
            erroredTask(request, newTask, signal);
            enqueueFlush(request);
            reader.cancel(signal).then(error, error);
        }
    }
    var model = [
        blob.type
    ], newTask = createTask(request, model, null, !1, request.abortableTasks), reader = blob.stream().getReader();
    request.cacheController.signal.addEventListener("abort", abortBlob);
    reader.read().then(progress).catch(error);
    return "$B" + newTask.id.toString(16);
}
var modelRoot = !1;
function renderModelDestructive(request, task, parent, parentPropertyName, value) {
    task.model = value;
    if (value === REACT_ELEMENT_TYPE) return "$";
    if (null === value) return null;
    if ("object" === typeof value) {
        switch(value.$$typeof){
            case REACT_ELEMENT_TYPE:
                var elementReference = null, writtenObjects = request.writtenObjects;
                if (null === task.keyPath && !task.implicitSlot) {
                    var existingReference = writtenObjects.get(value);
                    if (void 0 !== existingReference) {
                        if (modelRoot === value) modelRoot = null;
                        else return existingReference;
                    } else -1 === parentPropertyName.indexOf(":") && (parent = writtenObjects.get(parent), void 0 !== parent && (elementReference = parent + ":" + parentPropertyName, writtenObjects.set(value, elementReference)));
                }
                if (3200 < serializedSize) return deferTask(request, task);
                parentPropertyName = value.props;
                parent = parentPropertyName.ref;
                request = renderElement(request, task, value.type, value.key, void 0 !== parent ? parent : null, parentPropertyName);
                "object" === typeof request && null !== request && null !== elementReference && (writtenObjects.has(request) || writtenObjects.set(request, elementReference));
                return request;
            case REACT_LAZY_TYPE:
                if (3200 < serializedSize) return deferTask(request, task);
                task.thenableState = null;
                parentPropertyName = value._init;
                value = parentPropertyName(value._payload);
                if (12 === request.status) throw null;
                return renderModelDestructive(request, task, emptyRoot, "", value);
            case REACT_LEGACY_ELEMENT_TYPE:
                throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        }
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (void 0 !== request.temporaryReferences && (elementReference = request.temporaryReferences.get(value), void 0 !== elementReference)) return "$T" + elementReference;
        elementReference = request.writtenObjects;
        writtenObjects = elementReference.get(value);
        if ("function" === typeof value.then) {
            if (void 0 !== writtenObjects) {
                if (null !== task.keyPath || task.implicitSlot) return "$@" + serializeThenable(request, task, value).toString(16);
                if (modelRoot === value) modelRoot = null;
                else return writtenObjects;
            }
            request = "$@" + serializeThenable(request, task, value).toString(16);
            elementReference.set(value, request);
            return request;
        }
        if (void 0 !== writtenObjects) {
            if (modelRoot === value) {
                if (writtenObjects !== serializeByValueID(task.id)) return writtenObjects;
                modelRoot = null;
            } else return writtenObjects;
        } else if (-1 === parentPropertyName.indexOf(":") && (writtenObjects = elementReference.get(parent), void 0 !== writtenObjects)) {
            existingReference = parentPropertyName;
            if (isArrayImpl(parent) && parent[0] === REACT_ELEMENT_TYPE) switch(parentPropertyName){
                case "1":
                    existingReference = "type";
                    break;
                case "2":
                    existingReference = "key";
                    break;
                case "3":
                    existingReference = "props";
                    break;
                case "4":
                    existingReference = "_owner";
            }
            elementReference.set(value, writtenObjects + ":" + existingReference);
        }
        if (isArrayImpl(value)) return renderFragment(request, task, value);
        if (value instanceof Map) return value = Array.from(value), "$Q" + outlineModel(request, value).toString(16);
        if (value instanceof Set) return value = Array.from(value), "$W" + outlineModel(request, value).toString(16);
        if ("function" === typeof FormData && value instanceof FormData) return value = Array.from(value.entries()), "$K" + outlineModel(request, value).toString(16);
        if (value instanceof Error) return "$Z";
        if (value instanceof ArrayBuffer) return serializeTypedArray(request, "A", new Uint8Array(value));
        if (value instanceof Int8Array) return serializeTypedArray(request, "O", value);
        if (value instanceof Uint8Array) return serializeTypedArray(request, "o", value);
        if (value instanceof Uint8ClampedArray) return serializeTypedArray(request, "U", value);
        if (value instanceof Int16Array) return serializeTypedArray(request, "S", value);
        if (value instanceof Uint16Array) return serializeTypedArray(request, "s", value);
        if (value instanceof Int32Array) return serializeTypedArray(request, "L", value);
        if (value instanceof Uint32Array) return serializeTypedArray(request, "l", value);
        if (value instanceof Float32Array) return serializeTypedArray(request, "G", value);
        if (value instanceof Float64Array) return serializeTypedArray(request, "g", value);
        if (value instanceof BigInt64Array) return serializeTypedArray(request, "M", value);
        if (value instanceof BigUint64Array) return serializeTypedArray(request, "m", value);
        if (value instanceof DataView) return serializeTypedArray(request, "V", value);
        if ("function" === typeof Blob && value instanceof Blob) return serializeBlob(request, value);
        if (elementReference = getIteratorFn(value)) return parentPropertyName = elementReference.call(value), parentPropertyName === value ? "$i" + outlineModel(request, Array.from(parentPropertyName)).toString(16) : renderFragment(request, task, Array.from(parentPropertyName));
        if ("function" === typeof ReadableStream && value instanceof ReadableStream) return serializeReadableStream(request, task, value);
        elementReference = value[ASYNC_ITERATOR];
        if ("function" === typeof elementReference) return null !== task.keyPath ? (request = [
            REACT_ELEMENT_TYPE,
            REACT_FRAGMENT_TYPE,
            task.keyPath,
            {
                children: value
            }
        ], request = task.implicitSlot ? [
            request
        ] : request) : (parentPropertyName = elementReference.call(value), request = serializeAsyncIterable(request, task, value, parentPropertyName)), request;
        if (value instanceof Date) return "$D" + value.toJSON();
        request = getPrototypeOf(value);
        if (request !== ObjectPrototype && (null === request || null !== getPrototypeOf(request))) throw Error("Only plain objects, and a few built-ins, can be passed to Client Components from Server Components. Classes or null prototypes are not supported." + describeObjectForErrorMessage(parent, parentPropertyName));
        return value;
    }
    if ("string" === typeof value) {
        serializedSize += value.length;
        if ("Z" === value[value.length - 1] && parent[parentPropertyName] instanceof Date) return "$D" + value;
        if (1024 <= value.length && null !== byteLengthOfChunk) return request.pendingChunks++, task = request.nextChunkId++, emitTextChunk(request, task, value, !1), serializeByValueID(task);
        request = "$" === value[0] ? "$" + value : value;
        return request;
    }
    if ("boolean" === typeof value) return value;
    if ("number" === typeof value) return Number.isFinite(value) ? 0 === value && -Infinity === 1 / value ? "$-0" : value : Infinity === value ? "$Infinity" : -Infinity === value ? "$-Infinity" : "$NaN";
    if ("undefined" === typeof value) return "$undefined";
    if ("function" === typeof value) {
        if (value.$$typeof === CLIENT_REFERENCE_TAG$1) return serializeClientReference(request, parent, parentPropertyName, value);
        if (value.$$typeof === SERVER_REFERENCE_TAG) return task = request.writtenServerReferences, parentPropertyName = task.get(value), void 0 !== parentPropertyName ? request = "$F" + parentPropertyName.toString(16) : (parentPropertyName = value.$$bound, parentPropertyName = null === parentPropertyName ? null : Promise.resolve(parentPropertyName), request = outlineModel(request, {
            id: value.$$id,
            bound: parentPropertyName
        }), task.set(value, request), request = "$F" + request.toString(16)), request;
        if (void 0 !== request.temporaryReferences && (request = request.temporaryReferences.get(value), void 0 !== request)) return "$T" + request;
        if (value.$$typeof === TEMPORARY_REFERENCE_TAG) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
        if (/^on[A-Z]/.test(parentPropertyName)) throw Error("Event handlers cannot be passed to Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName) + "\nIf you need interactivity, consider converting part of this to a Client Component.");
        throw Error('Functions cannot be passed directly to Client Components unless you explicitly expose it by marking it with "use server". Or maybe you meant to call this function rather than return it.' + describeObjectForErrorMessage(parent, parentPropertyName));
    }
    if ("symbol" === typeof value) {
        task = request.writtenSymbols;
        elementReference = task.get(value);
        if (void 0 !== elementReference) return serializeByValueID(elementReference);
        elementReference = value.description;
        if (Symbol.for(elementReference) !== value) throw Error("Only global symbols received from Symbol.for(...) can be passed to Client Components. The symbol Symbol.for(" + (value.description + ") cannot be found among global symbols.") + describeObjectForErrorMessage(parent, parentPropertyName));
        request.pendingChunks++;
        parentPropertyName = request.nextChunkId++;
        parent = encodeReferenceChunk(request, parentPropertyName, "$S" + elementReference);
        request.completedImportChunks.push(parent);
        task.set(value, parentPropertyName);
        return serializeByValueID(parentPropertyName);
    }
    if ("bigint" === typeof value) return "$n" + value.toString(10);
    throw Error("Type " + typeof value + " is not supported in Client Component props." + describeObjectForErrorMessage(parent, parentPropertyName));
}
function logRecoverableError(request, error) {
    var prevRequest = currentRequest;
    currentRequest = null;
    try {
        var onError = request.onError;
        var errorDigest = supportsRequestStorage ? requestStorage.run(void 0, onError, error) : onError(error);
    } finally{
        currentRequest = prevRequest;
    }
    if (null != errorDigest && "string" !== typeof errorDigest) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof errorDigest + '" instead');
    return errorDigest || "";
}
function fatalError(request, error) {
    var onFatalError = request.onFatalError;
    onFatalError(error);
    null !== request.destination ? (request.status = 14, closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
    request.cacheController.abort(Error("The render was aborted due to a fatal error.", {
        cause: error
    }));
}
function emitErrorChunk(request, id, digest) {
    digest = {
        digest: digest
    };
    id = id.toString(16) + ":E" + stringify(digest) + "\n";
    id = stringToChunk(id);
    request.completedErrorChunks.push(id);
}
function emitModelChunk(request, id, json) {
    id = id.toString(16) + ":" + json + "\n";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id);
}
function emitTypedArrayChunk(request, id, tag, typedArray, debug) {
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    debug = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
    typedArray = 2048 < typedArray.byteLength ? debug.slice() : debug;
    debug = typedArray.byteLength;
    id = id.toString(16) + ":" + tag + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, typedArray);
}
function emitTextChunk(request, id, text, debug) {
    if (null === byteLengthOfChunk) throw Error("Existence of byteLengthOfChunk should have already been checked. This is a bug in React.");
    debug ? request.pendingDebugChunks++ : request.pendingChunks++;
    text = stringToChunk(text);
    debug = text.byteLength;
    id = id.toString(16) + ":T" + debug.toString(16) + ",";
    id = stringToChunk(id);
    request.completedRegularChunks.push(id, text);
}
function emitChunk(request, task, value) {
    var id = task.id;
    "string" === typeof value && null !== byteLengthOfChunk ? emitTextChunk(request, id, value, !1) : value instanceof ArrayBuffer ? emitTypedArrayChunk(request, id, "A", new Uint8Array(value), !1) : value instanceof Int8Array ? emitTypedArrayChunk(request, id, "O", value, !1) : value instanceof Uint8Array ? emitTypedArrayChunk(request, id, "o", value, !1) : value instanceof Uint8ClampedArray ? emitTypedArrayChunk(request, id, "U", value, !1) : value instanceof Int16Array ? emitTypedArrayChunk(request, id, "S", value, !1) : value instanceof Uint16Array ? emitTypedArrayChunk(request, id, "s", value, !1) : value instanceof Int32Array ? emitTypedArrayChunk(request, id, "L", value, !1) : value instanceof Uint32Array ? emitTypedArrayChunk(request, id, "l", value, !1) : value instanceof Float32Array ? emitTypedArrayChunk(request, id, "G", value, !1) : value instanceof Float64Array ? emitTypedArrayChunk(request, id, "g", value, !1) : value instanceof BigInt64Array ? emitTypedArrayChunk(request, id, "M", value, !1) : value instanceof BigUint64Array ? emitTypedArrayChunk(request, id, "m", value, !1) : value instanceof DataView ? emitTypedArrayChunk(request, id, "V", value, !1) : (value = stringify(value, task.toJSON), emitModelChunk(request, task.id, value));
}
function erroredTask(request, task, error) {
    task.status = 4;
    error = logRecoverableError(request, error, task);
    emitErrorChunk(request, task.id, error);
    request.abortableTasks.delete(task);
    callOnAllReadyIfReady(request);
}
var emptyRoot = {};
function retryTask(request, task) {
    if (0 === task.status) {
        task.status = 5;
        var parentSerializedSize = serializedSize;
        try {
            modelRoot = task.model;
            var resolvedModel = renderModelDestructive(request, task, emptyRoot, "", task.model);
            modelRoot = resolvedModel;
            task.keyPath = null;
            task.implicitSlot = !1;
            if ("object" === typeof resolvedModel && null !== resolvedModel) request.writtenObjects.set(resolvedModel, serializeByValueID(task.id)), emitChunk(request, task, resolvedModel);
            else {
                var json = stringify(resolvedModel);
                emitModelChunk(request, task.id, json);
            }
            task.status = 1;
            request.abortableTasks.delete(task);
            callOnAllReadyIfReady(request);
        } catch (thrownValue) {
            if (12 === request.status) {
                request.abortableTasks.delete(task);
                task.status = 0;
                var errorId = request.fatalError;
                abortTask(task);
                finishAbortedTask(task, request, errorId);
            } else {
                var x = thrownValue === SuspenseException ? getSuspendedThenable() : thrownValue;
                if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                    task.status = 0;
                    task.thenableState = getThenableStateAfterSuspending();
                    var ping = task.ping;
                    x.then(ping, ping);
                } else erroredTask(request, task, x);
            }
        } finally{
            serializedSize = parentSerializedSize;
        }
    }
}
function tryStreamTask(request, task) {
    var parentSerializedSize = serializedSize;
    try {
        emitChunk(request, task, task.model);
    } finally{
        serializedSize = parentSerializedSize;
    }
}
function performWork(request) {
    var prevDispatcher = ReactSharedInternalsServer.H;
    ReactSharedInternalsServer.H = HooksDispatcher;
    var prevRequest = currentRequest;
    currentRequest$1 = currentRequest = request;
    try {
        var pingedTasks = request.pingedTasks;
        request.pingedTasks = [];
        for(var i = 0; i < pingedTasks.length; i++)retryTask(request, pingedTasks[i]);
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    } finally{
        ReactSharedInternalsServer.H = prevDispatcher, currentRequest$1 = null, currentRequest = prevRequest;
    }
}
function abortTask(task) {
    0 === task.status && (task.status = 3);
}
function finishAbortedTask(task, request, errorId) {
    3 === task.status && (errorId = serializeByValueID(errorId), task = encodeReferenceChunk(request, task.id, errorId), request.completedErrorChunks.push(task));
}
function flushCompletedChunks(request) {
    var destination = request.destination;
    if (null !== destination) {
        currentView = new Uint8Array(2048);
        writtenBytes = 0;
        try {
            for(var importsChunks = request.completedImportChunks, i = 0; i < importsChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, importsChunks[i]);
            importsChunks.splice(0, i);
            var hintChunks = request.completedHintChunks;
            for(i = 0; i < hintChunks.length; i++)writeChunkAndReturn(destination, hintChunks[i]);
            hintChunks.splice(0, i);
            var regularChunks = request.completedRegularChunks;
            for(i = 0; i < regularChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, regularChunks[i]);
            regularChunks.splice(0, i);
            var errorChunks = request.completedErrorChunks;
            for(i = 0; i < errorChunks.length; i++)request.pendingChunks--, writeChunkAndReturn(destination, errorChunks[i]);
            errorChunks.splice(0, i);
        } finally{
            request.flushScheduled = !1, currentView && 0 < writtenBytes && (destination.enqueue(new Uint8Array(currentView.buffer, 0, writtenBytes)), currentView = null, writtenBytes = 0);
        }
    }
    0 === request.pendingChunks && (12 > request.status && request.cacheController.abort(Error("This render completed successfully. All cacheSignals are now aborted to allow clean up of any unused resources.")), null !== request.destination && (request.status = 14, request.destination.close(), request.destination = null));
}
function startWork(request) {
    request.flushScheduled = null !== request.destination;
    supportsRequestStorage ? scheduleMicrotask(function() {
        requestStorage.run(request, performWork, request);
    }) : scheduleMicrotask(function() {
        return performWork(request);
    });
    setTimeout(function() {
        10 === request.status && (request.status = 11);
    }, 0);
}
function enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, setTimeout(function() {
        request.flushScheduled = !1;
        flushCompletedChunks(request);
    }, 0));
}
function callOnAllReadyIfReady(request) {
    0 === request.abortableTasks.size && (request = request.onAllReady, request());
}
function startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            flushCompletedChunks(request);
        } catch (error) {
            logRecoverableError(request, error, null), fatalError(request, error);
        }
    }
}
function finishAbort(request, abortedTasks, errorId) {
    try {
        abortedTasks.forEach(function(task) {
            return finishAbortedTask(task, request, errorId);
        });
        var onAllReady = request.onAllReady;
        onAllReady();
        flushCompletedChunks(request);
    } catch (error) {
        logRecoverableError(request, error, null), fatalError(request, error);
    }
}
function abort(request, reason) {
    if (!(11 < request.status)) try {
        request.status = 12;
        request.cacheController.abort(reason);
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error("The render was aborted by the server without a reason.") : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error("The render was aborted by the server with a promise.") : reason, digest = logRecoverableError(request, error, null), errorId = request.nextChunkId++;
            request.fatalError = errorId;
            request.pendingChunks++;
            emitErrorChunk(request, errorId, digest, error, !1);
            abortableTasks.forEach(function(task) {
                return abortTask(task, request, errorId);
            });
            setTimeout(function() {
                return finishAbort(request, abortableTasks, errorId);
            }, 0);
        } else {
            var onAllReady = request.onAllReady;
            onAllReady();
            flushCompletedChunks(request);
        }
    } catch (error$23) {
        logRecoverableError(request, error$23, null), fatalError(request, error$23);
    }
}
function Chunk(status, value, reason, response) {
    this.status = status;
    this.value = value;
    this.reason = reason;
    this._response = response;
}
Chunk.prototype = Object.create(Promise.prototype);
Chunk.prototype.then = function(resolve, reject) {
    switch(this.status){
        case "resolved_model":
            initializeModelChunk(this);
    }
    switch(this.status){
        case "fulfilled":
            resolve(this.value);
            break;
        case "pending":
        case "blocked":
        case "cyclic":
            resolve && (null === this.value && (this.value = []), this.value.push(resolve));
            reject && (null === this.reason && (this.reason = []), this.reason.push(reject));
            break;
        default:
            reject(this.reason);
    }
};
function createPendingChunk(response) {
    return new Chunk("pending", null, null, response);
}
function wakeChunk(listeners, value) {
    for(var i = 0; i < listeners.length; i++)(0, listeners[i])(value);
}
function triggerErrorOnChunk(chunk, error) {
    if ("pending" !== chunk.status && "blocked" !== chunk.status) chunk.reason.error(error);
    else {
        var listeners = chunk.reason;
        chunk.status = "rejected";
        chunk.reason = error;
        null !== listeners && wakeChunk(listeners, error);
    }
}
function resolveModelChunk(chunk, value, id) {
    if ("pending" !== chunk.status) chunk = chunk.reason, "C" === value[0] ? chunk.close("C" === value ? '"$undefined"' : value.slice(1)) : chunk.enqueueModel(value);
    else {
        var resolveListeners = chunk.value, rejectListeners = chunk.reason;
        chunk.status = "resolved_model";
        chunk.value = value;
        chunk.reason = id;
        if (null !== resolveListeners) switch(initializeModelChunk(chunk), chunk.status){
            case "fulfilled":
                wakeChunk(resolveListeners, chunk.value);
                break;
            case "pending":
            case "blocked":
            case "cyclic":
                if (chunk.value) for(value = 0; value < resolveListeners.length; value++)chunk.value.push(resolveListeners[value]);
                else chunk.value = resolveListeners;
                if (chunk.reason) {
                    if (rejectListeners) for(value = 0; value < rejectListeners.length; value++)chunk.reason.push(rejectListeners[value]);
                } else chunk.reason = rejectListeners;
                break;
            case "rejected":
                rejectListeners && wakeChunk(rejectListeners, chunk.reason);
        }
    }
}
function createResolvedIteratorResultChunk(response, value, done) {
    return new Chunk("resolved_model", (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1, response);
}
function resolveIteratorResultChunk(chunk, value, done) {
    resolveModelChunk(chunk, (done ? '{"done":true,"value":' : '{"done":false,"value":') + value + "}", -1);
}
function loadServerReference$1(response, id, bound, parentChunk, parentObject, key) {
    var serverReference = resolveServerReference(response._bundlerConfig, id);
    id = preloadModule$1(serverReference);
    if (bound) bound = Promise.all([
        bound,
        id
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    });
    else if (id) bound = Promise.resolve(id).then(function() {
        return requireModule(serverReference);
    });
    else return requireModule(serverReference);
    bound.then(createModelResolver(parentChunk, parentObject, key, !1, response, createModel, []), createModelReject(parentChunk));
    return null;
}
function reviveModel(response, parentObj, parentKey, value, reference) {
    if ("string" === typeof value) return parseModelString(response, parentObj, parentKey, value, reference);
    if ("object" === typeof value && null !== value) {
        if (void 0 !== reference && void 0 !== response._temporaryReferences && response._temporaryReferences.set(value, reference), Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = reviveModel(response, value, "" + i, value[i], void 0 !== reference ? reference + ":" + i : void 0);
        else for(i in value)hasOwnProperty.call(value, i) && (parentObj = void 0 !== reference && -1 === i.indexOf(":") ? reference + ":" + i : void 0, parentObj = reviveModel(response, value, i, value[i], parentObj), void 0 !== parentObj ? value[i] = parentObj : delete value[i]);
    }
    return value;
}
var initializingChunk = null, initializingChunkBlockedModel = null;
function initializeModelChunk(chunk) {
    var prevChunk = initializingChunk, prevBlocked = initializingChunkBlockedModel;
    initializingChunk = chunk;
    initializingChunkBlockedModel = null;
    var rootReference = -1 === chunk.reason ? void 0 : chunk.reason.toString(16), resolvedModel = chunk.value;
    chunk.status = "cyclic";
    chunk.value = null;
    chunk.reason = null;
    try {
        var rawModel = JSON.parse(resolvedModel), value = reviveModel(chunk._response, {
            "": rawModel
        }, "", rawModel, rootReference);
        if (null !== initializingChunkBlockedModel && 0 < initializingChunkBlockedModel.deps) initializingChunkBlockedModel.value = value, chunk.status = "blocked";
        else {
            var resolveListeners = chunk.value;
            chunk.status = "fulfilled";
            chunk.value = value;
            null !== resolveListeners && wakeChunk(resolveListeners, value);
        }
    } catch (error) {
        chunk.status = "rejected", chunk.reason = error;
    } finally{
        initializingChunk = prevChunk, initializingChunkBlockedModel = prevBlocked;
    }
}
function reportGlobalError(response, error) {
    response._closed = !0;
    response._closedReason = error;
    response._chunks.forEach(function(chunk) {
        "pending" === chunk.status && triggerErrorOnChunk(chunk, error);
    });
}
function getChunk(response, id) {
    var chunks = response._chunks, chunk = chunks.get(id);
    chunk || (chunk = response._formData.get(response._prefix + id), chunk = null != chunk ? new Chunk("resolved_model", chunk, id, response) : response._closed ? new Chunk("rejected", null, response._closedReason, response) : createPendingChunk(response), chunks.set(id, chunk));
    return chunk;
}
function createModelResolver(chunk, parentObject, key, cyclic, response, map, path) {
    if (initializingChunkBlockedModel) {
        var blocked = initializingChunkBlockedModel;
        cyclic || blocked.deps++;
    } else blocked = initializingChunkBlockedModel = {
        deps: cyclic ? 0 : 1,
        value: null
    };
    return function(value) {
        for(var i = 1; i < path.length; i++)value = value[path[i]];
        parentObject[key] = map(response, value);
        "" === key && null === blocked.value && (blocked.value = parentObject[key]);
        blocked.deps--;
        0 === blocked.deps && "blocked" === chunk.status && (value = chunk.value, chunk.status = "fulfilled", chunk.value = blocked.value, null !== value && wakeChunk(value, blocked.value));
    };
}
function createModelReject(chunk) {
    return function(error) {
        return triggerErrorOnChunk(chunk, error);
    };
}
function getOutlinedModel(response, reference, parentObject, key, map) {
    reference = reference.split(":");
    var id = parseInt(reference[0], 16);
    id = getChunk(response, id);
    switch(id.status){
        case "resolved_model":
            initializeModelChunk(id);
    }
    switch(id.status){
        case "fulfilled":
            parentObject = id.value;
            for(key = 1; key < reference.length; key++)parentObject = parentObject[reference[key]];
            return map(response, parentObject);
        case "pending":
        case "blocked":
        case "cyclic":
            var parentChunk = initializingChunk;
            id.then(createModelResolver(parentChunk, parentObject, key, "cyclic" === id.status, response, map, reference), createModelReject(parentChunk));
            return null;
        default:
            throw id.reason;
    }
}
function createMap(response, model) {
    return new Map(model);
}
function createSet(response, model) {
    return new Set(model);
}
function extractIterator(response, model) {
    return model[Symbol.iterator]();
}
function createModel(response, model) {
    return model;
}
function parseTypedArray(response, reference, constructor, bytesPerElement, parentObject, parentKey) {
    reference = parseInt(reference.slice(2), 16);
    reference = response._formData.get(response._prefix + reference);
    reference = constructor === ArrayBuffer ? reference.arrayBuffer() : reference.arrayBuffer().then(function(buffer) {
        return new constructor(buffer);
    });
    bytesPerElement = initializingChunk;
    reference.then(createModelResolver(bytesPerElement, parentObject, parentKey, !1, response, createModel, []), createModelReject(bytesPerElement));
    return null;
}
function resolveStream(response, id, stream, controller) {
    var chunks = response._chunks;
    stream = new Chunk("fulfilled", stream, controller, response);
    chunks.set(id, stream);
    response = response._formData.getAll(response._prefix + id);
    for(id = 0; id < response.length; id++)chunks = response[id], "C" === chunks[0] ? controller.close("C" === chunks ? '"$undefined"' : chunks.slice(1)) : controller.enqueueModel(chunks);
}
function parseReadableStream(response, reference, type) {
    reference = parseInt(reference.slice(2), 16);
    var controller = null;
    type = new ReadableStream({
        type: type,
        start: function(c) {
            controller = c;
        }
    });
    var previousBlockedChunk = null;
    resolveStream(response, reference, type, {
        enqueueModel: function(json) {
            if (null === previousBlockedChunk) {
                var chunk = new Chunk("resolved_model", json, -1, response);
                initializeModelChunk(chunk);
                "fulfilled" === chunk.status ? controller.enqueue(chunk.value) : (chunk.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                }), previousBlockedChunk = chunk);
            } else {
                chunk = previousBlockedChunk;
                var chunk$26 = createPendingChunk(response);
                chunk$26.then(function(v) {
                    return controller.enqueue(v);
                }, function(e) {
                    return controller.error(e);
                });
                previousBlockedChunk = chunk$26;
                chunk.then(function() {
                    previousBlockedChunk === chunk$26 && (previousBlockedChunk = null);
                    resolveModelChunk(chunk$26, json, -1);
                });
            }
        },
        close: function() {
            if (null === previousBlockedChunk) controller.close();
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.close();
                });
            }
        },
        error: function(error) {
            if (null === previousBlockedChunk) controller.error(error);
            else {
                var blockedChunk = previousBlockedChunk;
                previousBlockedChunk = null;
                blockedChunk.then(function() {
                    return controller.error(error);
                });
            }
        }
    });
    return type;
}
function asyncIterator() {
    return this;
}
function createIterator(next) {
    next = {
        next: next
    };
    next[ASYNC_ITERATOR] = asyncIterator;
    return next;
}
function parseAsyncIterable(response, reference, iterator) {
    reference = parseInt(reference.slice(2), 16);
    var buffer = [], closed = !1, nextWriteIndex = 0, $jscomp$compprop2 = {};
    $jscomp$compprop2 = ($jscomp$compprop2[ASYNC_ITERATOR] = function() {
        var nextReadIndex = 0;
        return createIterator(function(arg) {
            if (void 0 !== arg) throw Error("Values cannot be passed to next() of AsyncIterables passed to Client Components.");
            if (nextReadIndex === buffer.length) {
                if (closed) return new Chunk("fulfilled", {
                    done: !0,
                    value: void 0
                }, null, response);
                buffer[nextReadIndex] = createPendingChunk(response);
            }
            return buffer[nextReadIndex++];
        });
    }, $jscomp$compprop2);
    iterator = iterator ? $jscomp$compprop2[ASYNC_ITERATOR]() : $jscomp$compprop2;
    resolveStream(response, reference, iterator, {
        enqueueModel: function(value) {
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !1) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !1);
            nextWriteIndex++;
        },
        close: function(value) {
            closed = !0;
            nextWriteIndex === buffer.length ? buffer[nextWriteIndex] = createResolvedIteratorResultChunk(response, value, !0) : resolveIteratorResultChunk(buffer[nextWriteIndex], value, !0);
            for(nextWriteIndex++; nextWriteIndex < buffer.length;)resolveIteratorResultChunk(buffer[nextWriteIndex++], '"$undefined"', !0);
        },
        error: function(error) {
            closed = !0;
            for(nextWriteIndex === buffer.length && (buffer[nextWriteIndex] = createPendingChunk(response)); nextWriteIndex < buffer.length;)triggerErrorOnChunk(buffer[nextWriteIndex++], error);
        }
    });
    return iterator;
}
function parseModelString(response, obj, key, value, reference) {
    if ("$" === value[0]) {
        switch(value[1]){
            case "$":
                return value.slice(1);
            case "@":
                return obj = parseInt(value.slice(2), 16), getChunk(response, obj);
            case "F":
                return value = value.slice(2), value = getOutlinedModel(response, value, obj, key, createModel), loadServerReference$1(response, value.id, value.bound, initializingChunk, obj, key);
            case "T":
                if (void 0 === reference || void 0 === response._temporaryReferences) throw Error("Could not reference an opaque temporary reference. This is likely due to misconfiguring the temporaryReferences options on the server.");
                return createTemporaryReference(response._temporaryReferences, reference);
            case "Q":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createMap);
            case "W":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, createSet);
            case "K":
                obj = value.slice(2);
                var formPrefix = response._prefix + obj + "_", data = new FormData();
                response._formData.forEach(function(entry, entryKey) {
                    entryKey.startsWith(formPrefix) && data.append(entryKey.slice(formPrefix.length), entry);
                });
                return data;
            case "i":
                return value = value.slice(2), getOutlinedModel(response, value, obj, key, extractIterator);
            case "I":
                return Infinity;
            case "-":
                return "$-0" === value ? -0 : -Infinity;
            case "N":
                return NaN;
            case "u":
                return;
            case "D":
                return new Date(Date.parse(value.slice(2)));
            case "n":
                return BigInt(value.slice(2));
        }
        switch(value[1]){
            case "A":
                return parseTypedArray(response, value, ArrayBuffer, 1, obj, key);
            case "O":
                return parseTypedArray(response, value, Int8Array, 1, obj, key);
            case "o":
                return parseTypedArray(response, value, Uint8Array, 1, obj, key);
            case "U":
                return parseTypedArray(response, value, Uint8ClampedArray, 1, obj, key);
            case "S":
                return parseTypedArray(response, value, Int16Array, 2, obj, key);
            case "s":
                return parseTypedArray(response, value, Uint16Array, 2, obj, key);
            case "L":
                return parseTypedArray(response, value, Int32Array, 4, obj, key);
            case "l":
                return parseTypedArray(response, value, Uint32Array, 4, obj, key);
            case "G":
                return parseTypedArray(response, value, Float32Array, 4, obj, key);
            case "g":
                return parseTypedArray(response, value, Float64Array, 8, obj, key);
            case "M":
                return parseTypedArray(response, value, BigInt64Array, 8, obj, key);
            case "m":
                return parseTypedArray(response, value, BigUint64Array, 8, obj, key);
            case "V":
                return parseTypedArray(response, value, DataView, 1, obj, key);
            case "B":
                return obj = parseInt(value.slice(2), 16), response._formData.get(response._prefix + obj);
        }
        switch(value[1]){
            case "R":
                return parseReadableStream(response, value, void 0);
            case "r":
                return parseReadableStream(response, value, "bytes");
            case "X":
                return parseAsyncIterable(response, value, !1);
            case "x":
                return parseAsyncIterable(response, value, !0);
        }
        value = value.slice(1);
        return getOutlinedModel(response, value, obj, key, createModel);
    }
    return value;
}
function createResponse(bundlerConfig, formFieldPrefix, temporaryReferences) {
    var backingFormData = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : new FormData(), chunks = new Map();
    return {
        _bundlerConfig: bundlerConfig,
        _prefix: formFieldPrefix,
        _formData: backingFormData,
        _chunks: chunks,
        _closed: !1,
        _closedReason: null,
        _temporaryReferences: temporaryReferences
    };
}
function close(response) {
    reportGlobalError(response, Error("Connection closed."));
}
function loadServerReference(bundlerConfig, id, bound) {
    var serverReference = resolveServerReference(bundlerConfig, id);
    bundlerConfig = preloadModule$1(serverReference);
    return bound ? Promise.all([
        bound,
        bundlerConfig
    ]).then(function(_ref) {
        _ref = _ref[0];
        var fn = requireModule(serverReference);
        return fn.bind.apply(fn, [
            null
        ].concat(_ref));
    }) : bundlerConfig ? Promise.resolve(bundlerConfig).then(function() {
        return requireModule(serverReference);
    }) : Promise.resolve(requireModule(serverReference));
}
function decodeBoundActionMetaData(body, serverManifest, formFieldPrefix) {
    body = createResponse(serverManifest, formFieldPrefix, void 0, body);
    close(body);
    body = getChunk(body, 0);
    body.then(function() {});
    if ("fulfilled" !== body.status) throw body.reason;
    return body.value;
}
function decodeAction$1(body, serverManifest) {
    var formData = new FormData(), action = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_") ? key.startsWith("$ACTION_REF_") ? (value = "$ACTION_" + key.slice(12) + ":", value = decodeBoundActionMetaData(body, serverManifest, value), action = loadServerReference(serverManifest, value.id, value.bound)) : key.startsWith("$ACTION_ID_") && (value = key.slice(11), action = loadServerReference(serverManifest, value, null)) : formData.append(key, value);
    });
    return null === action ? null : action.then(function(fn) {
        return fn.bind(null, formData);
    });
}
function decodeFormState$1(actionResult, body, serverManifest) {
    var keyPath = body.get("$ACTION_KEY");
    if ("string" !== typeof keyPath) return Promise.resolve(null);
    var metaData = null;
    body.forEach(function(value, key) {
        key.startsWith("$ACTION_REF_") && (value = "$ACTION_" + key.slice(12) + ":", metaData = decodeBoundActionMetaData(body, serverManifest, value));
    });
    if (null === metaData) return Promise.resolve(null);
    var referenceId = metaData.id;
    return Promise.resolve(metaData.bound).then(function(bound) {
        return null === bound ? null : [
            actionResult,
            keyPath,
            referenceId,
            bound.length - 1
        ];
    });
}
var serverManifest = {};
exports.createClientReference = function(id, exportName, bundles, importMap) {
    return {
        $$typeof: CLIENT_REFERENCE_TAG$1,
        $$id: id,
        $$name: exportName,
        $$bundles: bundles,
        $$importMap: importMap
    };
};
exports.createTemporaryReferenceSet = function() {
    return new WeakMap();
};
exports.decodeAction = function(body) {
    return decodeAction$1(body, serverManifest);
};
exports.decodeFormState = function(actionResult, body) {
    return decodeFormState$1(actionResult, body, serverManifest);
};
exports.decodeReply = function(body, options) {
    if ("string" === typeof body) {
        var form = new FormData();
        form.append("0", body);
        body = form;
    }
    body = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0, body);
    options = getChunk(body, 0);
    close(body);
    return options;
};
exports.decodeReplyFromAsyncIterable = function(iterable, options) {
    function progress(entry) {
        if (entry.done) close(response);
        else {
            entry = entry.value;
            var name = entry[0];
            entry = entry[1];
            if ("string" === typeof entry) {
                response._formData.append(name, entry);
                var prefix = response._prefix;
                if (name.startsWith(prefix)) {
                    var chunks = response._chunks;
                    name = +name.slice(prefix.length);
                    (chunks = chunks.get(name)) && resolveModelChunk(chunks, entry, name);
                }
            } else response._formData.append(name, entry);
            iterator.next().then(progress, error);
        }
    }
    function error(reason) {
        reportGlobalError(response, reason);
        "function" === typeof iterator.throw && iterator.throw(reason).then(error, error);
    }
    var iterator = iterable[ASYNC_ITERATOR](), response = createResponse(serverManifest, "", options ? options.temporaryReferences : void 0);
    iterator.next().then(progress, error);
    return getChunk(response, 0);
};
exports.loadServerAction = function(id) {
    var reference = resolveServerReference(serverManifest, id);
    return Promise.resolve(reference).then(function() {
        return preloadModule$1(reference);
    }).then(function() {
        var fn = requireModule(reference);
        if ("function" !== typeof fn) throw Error("Server actions must be functions");
        return fn;
    });
};
exports.registerServerActions = function(manifest) {
    serverManifest = manifest;
};
exports.registerServerReference = function(reference, id, exportName) {
    return Object.defineProperties(reference, {
        $$typeof: {
            value: SERVER_REFERENCE_TAG
        },
        $$id: {
            value: id + "#" + exportName,
            configurable: !0
        },
        $$bound: {
            value: null,
            configurable: !0
        },
        bind: {
            value: bind,
            configurable: !0
        }
    });
};
exports.renderToReadableStream = function(model, options) {
    var request = new RequestInstance(20, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, noop, noop, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
    if (options && options.signal) {
        var signal = options.signal;
        if (signal.aborted) abort(request, signal.reason);
        else {
            var listener = function() {
                abort(request, signal.reason);
                signal.removeEventListener("abort", listener);
            };
            signal.addEventListener("abort", listener);
        }
    }
    return new ReadableStream({
        type: "bytes",
        start: function() {
            startWork(request);
        },
        pull: function(controller) {
            startFlowing(request, controller);
        },
        cancel: function(reason) {
            request.destination = null;
            abort(request, reason);
        }
    }, {
        highWaterMark: 0
    });
};
exports.unstable_prerender = function(model, options) {
    return new Promise(function(resolve, reject) {
        var request = new RequestInstance(21, model, null, options ? options.onError : void 0, options ? options.onPostpone : void 0, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            resolve({
                prelude: stream
            });
        }, reject, options ? options.identifierPrefix : void 0, options ? options.temporaryReferences : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) abort(request, signal.reason);
            else {
                var listener = function() {
                    abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        startWork(request);
    });
};

},{"2381f0f3ff03ff95":"gC2PC","6db66a729b66b575":"a1TxN"}],"gC2PC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"c4Fud"}],"c4Fud":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.2.4";

},{"6a05e75e64e4f862":"a1TxN"}],"8BIYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownMenu", ()=>MarkdownMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _checkmarkCircle = require("@react-spectrum/s2/icons/CheckmarkCircle");
var _checkmarkCircleDefault = parcelHelpers.interopDefault(_checkmarkCircle);
var _copy = require("@react-spectrum/s2/icons/Copy");
var _copyDefault = parcelHelpers.interopDefault(_copy);
var _library = require("./library");
var _more = require("@react-spectrum/s2/icons/More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function MarkdownMenu({ name, url }) {
    let mdUrl = (url ?? '').replace(/\.html?$/i, '') + '.md';
    let [isCopied, setIsCopied] = (0, _react.useState)(false);
    let [isPending, setPending] = (0, _react.useState)(false);
    let timeout = (0, _react.useRef)(null);
    let pageUrl = typeof window !== 'undefined' && url ? new URL(url, window.location.origin).href : url ?? '';
    let fullMdUrl = typeof window !== 'undefined' && mdUrl ? new URL(mdUrl, window.location.origin).href : mdUrl;
    let library = url ? (0, _library.getLibraryLabel)((0, _library.getLibraryFromUrl)(name)) : '';
    let aiPrompt = `Answer questions about the following ${library} documentation page: ${pageUrl}\nMarkdown source: ${fullMdUrl}`;
    let chatGptUrl = `https://chatgpt.com/?q=${encodeURIComponent(aiPrompt)}`;
    let claudeUrl = `https://claude.ai/new?q=${encodeURIComponent(aiPrompt)}`;
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    let handleCopy = (0, _react.useCallback)(async ()=>{
        if (timeout.current) clearTimeout(timeout.current);
        if (typeof navigator !== 'undefined' && navigator.clipboard) try {
            setPending(true);
            await navigator.clipboard.write([
                new ClipboardItem({
                    ['text/plain']: fetch(mdUrl).then((res)=>res.text())
                })
            ]);
            setIsCopied(true);
            timeout.current = setTimeout(()=>setIsCopied(false), 2000);
        } catch  {
            (0, _s2.ToastQueue).negative('Failed to copy markdown.');
        } finally{
            setPending(false);
        }
    }, [
        mdUrl
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: " sd171 _Ce171 Sp171 Rp171 Qf171",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.ActionButton), {
                isQuiet: true,
                size: "M",
                onPress: handleCopy,
                isPending: isPending,
                children: [
                    isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkCircleDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Text), {
                        children: "Copy for LLM"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.MenuTrigger), {
                align: "end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                        size: "M",
                        isQuiet: true,
                        "aria-label": "Markdown options",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.Menu), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "view",
                                href: mdUrl,
                                target: "_blank",
                                children: "View as Markdown"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "chatgpt",
                                href: chatGptUrl,
                                target: "_blank",
                                children: "Open in ChatGPT"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.MenuItem), {
                                id: "claude",
                                href: claudeUrl,
                                target: "_blank",
                                children: "Open in Claude"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"0":"gLyho","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["Menu","1F0Yz"],["MenuItem","1F0Yz"],["MenuTrigger","1F0Yz"],["Text","10r6w"],["ToastQueue","9R0uF"]],"@react-spectrum/s2/icons/CheckmarkCircle":"6hpGX","@react-spectrum/s2/icons/Copy":"6imrL","./library":"a5H2j","@react-spectrum/s2/icons/More":"gP3id","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gLyho":[function() {},{}],"iKE7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollableToc", ()=>ScrollableToc);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function ScrollableToc({ children }) {
    let [topMaskSize, setTopMaskSize] = (0, _react.useState)(0);
    let [bottomMaskSize, setBottomMaskSize] = (0, _react.useState)(0);
    let scrollRef = (0, _react.useRef)(null);
    let updateMasks = (element)=>{
        let scrollTop = element.scrollTop;
        let scrollHeight = element.scrollHeight;
        let clientHeight = element.clientHeight;
        let distanceFromBottom = scrollHeight - scrollTop - clientHeight;
        setTopMaskSize(Math.min(scrollTop, 32));
        setBottomMaskSize(Math.min(distanceFromBottom, 32));
    };
    (0, _react.useEffect)(()=>{
        if (scrollRef.current) updateMasks(scrollRef.current);
    }, [
        children
    ]);
    let maskImage;
    if (topMaskSize > 0 || bottomMaskSize > 0) {
        let parts = [];
        if (topMaskSize > 0) {
            parts.push('transparent 0px');
            parts.push(`black ${topMaskSize}px`);
        } else parts.push('black 0px');
        if (bottomMaskSize > 0) {
            parts.push(`black calc(100% - ${bottomMaskSize}px)`);
            parts.push('transparent 100%');
        } else parts.push('black 100%');
        maskImage = `linear-gradient(to bottom, ${parts.join(', ')})`;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: scrollRef,
        onScroll: (e)=>updateMasks(e.currentTarget),
        style: {
            maskImage
        },
        className: " Pa171 _vb171 Ma171 Ka171",
        children: children
    });
}

},{"0":"l9NJC","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l9NJC":[function() {},{}],"b3IWk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _contrast = require("@react-spectrum/s2/icons/Contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _s2 = require("@react-spectrum/s2");
var _pageUtils = require("./pageUtils");
var _library = require("./library");
var _githubLogo = require("./icons/GithubLogo");
var _githubLogoDefault = parcelHelpers.interopDefault(_githubLogo);
var _link = require("./Link");
var _lighten = require("@react-spectrum/s2/icons/Lighten");
var _lightenDefault = parcelHelpers.interopDefault(_lighten);
var _npmLogo = require("./icons/NpmLogo");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _searchMenuTrigger = require("./SearchMenuTrigger");
var _searchMenuTriggerDefault = parcelHelpers.interopDefault(_searchMenuTrigger);
var _utils = require("@react-aria/utils");
var _router = require("./Router");
var _settingsContext = require("./SettingsContext");
'use client';
function getButtonText(currentPage) {
    return (0, _library.getLibraryLabel)((0, _library.getLibraryFromPage)(currentPage));
}
function getButtonIcon(currentPage) {
    return (0, _library.getLibraryIcon)((0, _library.getLibraryFromPage)(currentPage));
}
const libraryStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    rules += ' Oh171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' _Mc171';
    rules += ' _Kd171';
    rules += ' Se171';
    rules += ' Re171';
    rules += ' sd171';
    rules += ' eb171';
    rules += ' qi9a9Xd171';
    rules += ' qp5NLVAe171';
    rules += ' _Xa171';
    rules += ' MBaYFfc171';
    rules += ' o5NLVAe171';
    rules += ' n5NLVAe171';
    rules += ' k5NLVAe171';
    rules += ' j5NLVAe171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    if (props.isPressed) rules += ' gF171';
    else if (props.isFocusVisible) rules += ' gF171';
    else if (props.isHovered) rules += ' gF171';
    else rules += ' g9171';
    rules += ' IUNeF3c171';
    return rules;
};
const colorSchemeToggleStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    rules += ' Oh171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' _Mc171';
    rules += ' _Kd171';
    rules += ' uk171';
    rules += ' ucJ9TBTb171';
    rules += ' ud3Euai171';
    rules += ' uea171';
    rules += ' ugb171';
    rules += ' uhd171';
    rules += ' uje171';
    rules += ' u2NhKxcl171';
    rules += ' uic171';
    rules += ' -_6BNtrc-c171';
    rules += ' vFHT6Dd171';
    rules += ' xb171';
    rules += ' _xa171';
    rules += ' _Fd171';
    rules += ' _FnuYUweb171';
    rules += ' pt171';
    rules += ' _Xa171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    if (props.isPressed) rules += ' gF171';
    else if (props.isFocusVisible) rules += ' gF171';
    else if (props.isHovered) rules += ' gF171';
    else rules += ' g9171';
    rules += ' Z4dY0ec171';
    rules += ' F4dY0ec171';
    rules += ' sd171';
    rules += ' eb171';
    rules += ' _Ca171';
    rules += ' o5NLVAe171';
    rules += ' n5NLVAe171';
    rules += ' k5NLVAe171';
    rules += ' j5NLVAe171';
    rules += ' _ka171';
    rules += ' ha171';
    rules += ' ma171';
    rules += ' la171';
    return rules;
};
const iconContainerStyles = " _Pc171 ZifsFYc171 FifsFYc171";
function ColorSchemeToggle() {
    let { colorScheme, toggleColorScheme, systemColorScheme } = (0, _settingsContext.useSettings)();
    let isOverriding = colorScheme !== systemColorScheme;
    let label = isOverriding ? `Using ${colorScheme} mode (press to use system)` : `Using system ${systemColorScheme} mode (press to switch)`;
    let ref = (0, _react.useRef)(null);
    let isDark = colorScheme === 'dark';
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ref: ref,
        "aria-label": label,
        onPress: toggleColorScheme,
        className: (renderProps)=>colorSchemeToggleStyles(renderProps),
        style: (0, _s2.pressScale)(ref),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: iconContainerStyles,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contrastDefault.default), {
                    UNSAFE_style: {
                        position: 'absolute',
                        inset: 0,
                        opacity: isDark ? 0 : 1,
                        transform: isDark ? 'rotate(-90deg) scale(0.5)' : 'rotate(0deg) scale(1)',
                        transition: 'opacity 200ms ease-out, transform 200ms ease-out'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lightenDefault.default), {
                    UNSAFE_style: {
                        position: 'absolute',
                        inset: 0,
                        opacity: isDark ? 1 : 0,
                        transform: isDark ? 'rotate(0deg) scale(1)' : 'rotate(90deg) scale(0.5)',
                        transition: 'opacity 200ms ease-out, transform 200ms ease-out'
                    }
                })
            ]
        })
    });
// oxlint-enable react/react-compiler
}
function Header() {
    const { currentPage } = (0, _router.useRouter)();
    const [searchOpen, setSearchOpen] = (0, _react.useState)(false);
    const searchMenuId = (0, _react.useId)();
    let ref = (0, _react.useRef)(null);
    let iconRef = (0, _react.useRef)(null);
    let labelRef = (0, _react.useRef)(null);
    let searchRef = (0, _react.useRef)(null);
    let renderCallback = (0, _react.useRef)(null);
    let openSearchMenu = async ()=>{
        if (!document.startViewTransition) {
            setSearchOpen((prev)=>!prev);
            return;
        }
        // Preload SearchMenu so it is ready to render immediately.
        await (0, _searchMenuTrigger.preloadSearchMenu)();
        // Don't transition the entire page.
        document.documentElement.style.viewTransitionName = 'none';
        iconRef.current.style.viewTransitionName = 'search-menu-icon';
        labelRef.current.style.viewTransitionName = 'search-menu-label';
        searchRef.current.style.viewTransitionName = 'search-menu-search-field';
        let viewTransition = document.startViewTransition(()=>{
            // Wait until next render. Using flushSync causes flickering.
            return new Promise((resolve)=>{
                iconRef.current.style.viewTransitionName = '';
                labelRef.current.style.viewTransitionName = '';
                searchRef.current.style.viewTransitionName = '';
                renderCallback.current = resolve;
                setSearchOpen((prev)=>!prev);
            });
        });
        viewTransition.finished.then(()=>{
            document.documentElement.style.viewTransitionName = '';
        });
    };
    let closeSearchMenu = ()=>{
        if (!document.startViewTransition) {
            setSearchOpen(false);
            return;
        }
        document.documentElement.style.viewTransitionName = 'none';
        let viewTransition = document.startViewTransition(()=>{
            return new Promise((resolve)=>{
                renderCallback.current = resolve;
                setSearchOpen(false);
                iconRef.current.style.viewTransitionName = 'search-menu-icon';
                labelRef.current.style.viewTransitionName = 'search-menu-label';
                searchRef.current.style.viewTransitionName = 'search-menu-search-field';
            });
        });
        viewTransition.finished.then(()=>{
            document.documentElement.style.viewTransitionName = '';
            iconRef.current.style.viewTransitionName = '';
            labelRef.current.style.viewTransitionName = '';
            searchRef.current.style.viewTransitionName = '';
        });
    };
    (0, _utils.useLayoutEffect)(()=>{
        renderCallback.current?.();
        renderCallback.current = null;
    });
    let library = (0, _library.getLibraryFromPage)(currentPage);
    let subdirectory = 's2';
    if (library === 'react-aria') // the internationalized library has no homepage so i've chosen to route it to the react aria homepage
    subdirectory = 'react-aria';
    let baseUrl = (0, _pageUtils.getBaseUrl)(subdirectory);
    let homepage = `${baseUrl}/`;
    let docs = `${baseUrl}/getting-started`;
    let release = `${baseUrl}/releases/`;
    let blog = `${(0, _pageUtils.getBaseUrl)('react-aria')}/blog/`;
    let npm = subdirectory === 's2' ? '@react-spectrum/s2' : 'react-aria-components';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
            className: " Za171 sk171 spd171 _Ca171",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: " Za171 se171 Duowq171 eb171",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " __Ad171",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Link), {
                            href: homepage,
                            ref: ref,
                            // oxlint-disable-next-line react/react-compiler
                            style: (0, _s2.pressScale)(ref, {
                                visibility: searchOpen ? 'hidden' : 'visible'
                            }),
                            className: (renderProps)=>libraryStyles({
                                    ...renderProps
                                }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    ref: iconRef,
                                    children: getButtonIcon(currentPage)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: " uk171 ucJ9TBTb171 ud3Euai171 uea171 ugb171 uhd171 uje171 u2NhKxcl171 uic171 -_6BNtrc-f171 vFHT6Dd171 xe171 _xa171 xX0cczbd171 _xX0cczba171 _Fd171 _FnuYUweb171 po171",
                                    ref: labelRef,
                                    children: getButtonText(currentPage)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        ref: searchRef,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchMenuTriggerDefault.default), {
                            onOpen: openSearchMenu,
                            onClose: closeSearchMenu,
                            isSearchOpen: searchOpen,
                            overlayId: searchMenuId
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: " sd171 eb171 UR3ltQc171 qR3ltQc171 __Ac171",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                                href: docs,
                                children: "Docs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                                href: release,
                                children: "Releases"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                                href: blog,
                                target: subdirectory === 's2' ? '_blank' : '',
                                rel: "noopener noreferrer",
                                children: "Blog"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                                "aria-label": "GitHub",
                                href: "https://github.com/adobe/react-spectrum",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _githubLogoDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.HeaderLink), {
                                "aria-label": "npm",
                                href: `https://npmjs.com/${npm}`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _npmLogo.NpmLogo), {})
                            }),
                            library !== 'react-aria' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Divider), {
                                        orientation: "vertical",
                                        UNSAFE_style: {
                                            marginBlock: 4
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeToggle, {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Link","fOCdV"]],"@react-spectrum/s2/icons/Contrast":"jAv02","@react-spectrum/s2":[["Divider","kGk2u"],["pressScale","8Ufux"]],"./pageUtils":"73Jzg","./library":"a5H2j","./icons/GithubLogo":"dcOQ5","./Link":"el6b6","@react-spectrum/s2/icons/Lighten":"8rFkP","./icons/NpmLogo":"dCdiF","react":"a1TxN","./SearchMenuTrigger":"kwXgr","@react-aria/utils":"k6VV7","./Router":"jI9xq","./SettingsContext":"7F6kW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fM2eg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileHeader", ()=>MobileHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _s2 = require("@react-spectrum/s2");
var _reactAriaComponents = require("react-aria-components");
var _contrast = require("@react-spectrum/s2/icons/Contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _pageUtils = require("./pageUtils");
var _library = require("./library");
var _lighten = require("@react-spectrum/s2/icons/Lighten");
var _lightenDefault = parcelHelpers.interopDefault(_lighten);
var _menuHamburger = require("@react-spectrum/s2/icons/MenuHamburger");
var _menuHamburgerDefault = parcelHelpers.interopDefault(_menuHamburger);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _constants = require("./constants");
var _utils = require("@react-aria/utils");
var _router = require("./Router");
var _settingsContext = require("./SettingsContext");
var _searchMenuCss = require("./SearchMenu.css");
'use client';
const MobileSearchMenu = /*#__PURE__*/ (0, _react.lazy)(()=>require("9e1014ecc3960d12").then(({ MobileSearchMenu })=>({
            default: MobileSearchMenu
        })));
let fadeOut = "zamT8b";
let shadow = "XYaG5b";
let fadeIn = "nToi3b";
const animation = {
    animationDuration: '1s',
    animationPlayState: {
        default: 'paused',
        '@supports (animation-timeline: scroll())': 'running'
    },
    animationFillMode: 'both',
    transitionTimingFunction: 'linear'
};
const animationRange = '24px 64px';
const colorSchemeToggleStyles = function anonymous(props) {
    let rules = " ";
    if (props.isFocusVisible) rules += ' _Lf171';
    else rules += ' _Le171';
    rules += ' Oh171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' OlOVIhfcebS7sd171';
    rules += ' _Mc171';
    rules += ' _Kd171';
    rules += ' uk171';
    rules += ' ucJ9TBTb171';
    rules += ' ud3Euai171';
    rules += ' uea171';
    rules += ' ugb171';
    rules += ' uhd171';
    rules += ' uje171';
    rules += ' u2NhKxcl171';
    rules += ' uic171';
    rules += ' -_6BNtrc-c171';
    rules += ' vFHT6Dd171';
    rules += ' xb171';
    rules += ' _xa171';
    rules += ' _Fd171';
    rules += ' _FnuYUweb171';
    rules += ' pt171';
    rules += ' _Xa171';
    rules += ' Yd171';
    rules += ' Xb171';
    rules += ' _2b171';
    if (props.isPressed) rules += ' gF171';
    else if (props.isFocusVisible) rules += ' gF171';
    else if (props.isHovered) rules += ' gF171';
    else rules += ' g9171';
    rules += ' Z4dY0ec171';
    rules += ' F4dY0ec171';
    rules += ' sd171';
    rules += ' eb171';
    rules += ' _Ca171';
    rules += ' o5NLVAe171';
    rules += ' n5NLVAe171';
    rules += ' k5NLVAe171';
    rules += ' j5NLVAe171';
    rules += ' _ka171';
    rules += ' ha171';
    rules += ' ma171';
    rules += ' la171';
    return rules;
};
const iconContainerStyles = " _Pc171 ZifsFYc171 FifsFYc171";
function ColorSchemeToggle() {
    let { colorScheme, toggleColorScheme, systemColorScheme } = (0, _settingsContext.useSettings)();
    let isOverriding = colorScheme !== systemColorScheme;
    let label = isOverriding ? `Using ${colorScheme} mode (press to use system)` : `Using system ${systemColorScheme} mode (press to switch)`;
    let ref = (0, _react.useRef)(null);
    let isDark = colorScheme === 'dark';
    // oxlint-disable react/react-compiler
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ref: ref,
        "aria-label": label,
        onPress: toggleColorScheme,
        className: (renderProps)=>colorSchemeToggleStyles(renderProps),
        style: (0, _s2.pressScale)(ref),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            className: iconContainerStyles,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contrastDefault.default), {
                    UNSAFE_style: {
                        position: 'absolute',
                        inset: 0,
                        opacity: isDark ? 0 : 1,
                        transform: isDark ? 'rotate(-90deg) scale(0.5)' : 'rotate(0deg) scale(1)',
                        transition: 'opacity 200ms ease-out, transform 200ms ease-out'
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lightenDefault.default), {
                    UNSAFE_style: {
                        position: 'absolute',
                        inset: 0,
                        opacity: isDark ? 1 : 0,
                        transform: isDark ? 'rotate(0deg) scale(1)' : 'rotate(90deg) scale(0.5)',
                        transition: 'opacity 200ms ease-out, transform 200ms ease-out'
                    }
                })
            ]
        })
    });
// oxlint-enable react/react-compiler
}
function MobileHeader({ toc }) {
    let ref = (0, _react.useRef)(null);
    let linkRef = (0, _react.useRef)(null);
    let labelRef = (0, _react.useRef)(null);
    let { colorScheme } = (0, _settingsContext.useSettings)();
    (0, _react.useEffect)(()=>{
        // Tiny polyfill for scroll driven animations.
        // Element must have animationDuration: 1s and animationPlayState: paused.
        if (!CSS.supports('(animation-timeline: scroll())') && ref.current) {
            let [start, end] = animationRange.split(' ').map((v)=>parseInt(v, 10));
            let animations = ref.current.getAnimations({
                subtree: true
            });
            let onScroll = ()=>{
                // Calculate animation time based on percentage of animationRange * duration.
                let time = Math.max(0, Math.min(end, window.scrollY - start) / (end - start)) * 1000;
                for (let animation of animations)animation.currentTime = time;
            };
            window.addEventListener('scroll', onScroll, {
                passive: true
            });
            return ()=>window.removeEventListener('scroll', onScroll);
        }
    }, []);
    let { currentPage } = (0, _router.useRouter)();
    let library = (0, _library.getLibraryFromPage)(currentPage);
    let icon = (0, _library.getLibraryIcon)(library);
    let subdirectory = 's2';
    if (library === 'react-aria') // the internationalized library has no homepage so i've chosen to route it to the react aria homepage
    subdirectory = 'react-aria';
    let baseUrl = (0, _pageUtils.getBaseUrl)(subdirectory);
    let homepage = `${baseUrl}/`;
    let [isOpen, setOpen] = (0, _react.useState)(false);
    let [wasOpen, setWasOpen] = (0, _react.useState)(isOpen);
    let [isTransitioning, setTransitioning] = (0, _react.useState)(false);
    let renderCallback = (0, _react.useRef)(null);
    let onOpenChange = (isOpen)=>{
        if (!document.startViewTransition) {
            setOpen(false);
            if (isOpen) setWasOpen(true);
            return;
        }
        // Don't transition the entire page.
        document.documentElement.style.viewTransitionName = 'none';
        // Only transition label if it is visible (scrolled to the top of the page).
        if (window.scrollY === 0 && labelRef.current && isOpen) labelRef.current.style.viewTransitionName = 'search-menu-label';
        let viewTransition = document.startViewTransition(()=>{
            if (labelRef.current && window.scrollY === 0) labelRef.current.style.viewTransitionName = !isOpen ? 'search-menu-label' : '';
            // Wait until next render. Using flushSync causes flickering.
            return new Promise((resolve)=>{
                renderCallback.current = resolve;
                setOpen(isOpen);
                setTransitioning(true);
                if (isOpen) setWasOpen(true);
            });
        });
        viewTransition.finished.then(()=>{
            document.documentElement.style.viewTransitionName = '';
            labelRef.current.style.viewTransitionName = '';
            setTransitioning(false);
        });
    };
    (0, _utils.useLayoutEffect)(()=>{
        renderCallback.current?.();
        renderCallback.current = null;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: " _Pe171 Wr171 Za171 Te171 Qe171 Se171 Re171 _oa171 sd171 spk171 eb171 Ui9a9Xd171 qi9a9Xd171 _9c171 _Nb171 Pb171 -SQSLJb-gX171 -z0sPGb-g_g171 -_5sGM4c-_nLeasBb171 _eL2Ky171 -aGzJ7c-1Za9w171 -aGzJ7c-Qlsn9mNcQZb171 _fb171 _2d171",
        style: {
            animationName: shadow,
            animationTimeline: 'scroll()',
            animationRange,
            // Pause scroll animation during view transition to avoid flicker in Safari.
            animationPlayState: isTransitioning ? 'paused' : undefined
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _ub171",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Link), {
                    href: homepage,
                    ref: linkRef,
                    // oxlint-disable-next-line react/react-compiler
                    style: (0, _s2.pressScale)(linkRef),
                    className: function anonymous(props) {
                        let rules = " ";
                        if (props.isFocusVisible) rules += ' _Lf171';
                        else rules += ' _Le171';
                        rules += ' Oh171';
                        rules += ' OlOVIhfcebS7sd171';
                        rules += ' OlOVIhfcebS7sd171';
                        rules += ' _Mc171';
                        rules += ' _Kd171';
                        rules += ' sd171';
                        rules += ' eb171';
                        rules += ' ZJ171';
                        rules += ' Ui9a9Xd171';
                        rules += ' qi9a9Xd171';
                        rules += ' oH5kTnc171';
                        rules += ' nH5kTnc171';
                        rules += ' kH5kTnc171';
                        rules += ' jH5kTnc171';
                        rules += ' _Xa171';
                        rules += ' Yd171';
                        rules += ' Xb171';
                        rules += ' _2b171';
                        rules += ' __ca171';
                        return rules;
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                viewTransitionName: 'search-menu-icon',
                                display: isOpen ? 'none' : undefined
                            },
                            children: icon
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            ref: labelRef,
                            className: " uk171 ucJ9TBTb171 ud3Euai171 uea171 ugb171 uhd171 uje171 u2NhKxcl171 uic171 -_6BNtrc-f171 vFHT6Dd171 xe171 _xa171 xX0cczbd171 _xX0cczba171 xfe171 _xfa171 xfX0cczbd171 _xfX0cczba171 _Fd171 _FnuYUweb171 po171 _7c171 _eL2Ky171 -aGzJ7c-1Za9w171 -aGzJ7c-Qlsn9mNcQZb171 _fb171 _2d171",
                            style: toc ? {
                                animationName: fadeOut,
                                animationTimeline: 'scroll()',
                                animationRange,
                                animationPlayState: isTransitioning ? 'paused' : undefined,
                                display: isOpen ? 'none' : undefined
                            } : undefined,
                            children: (0, _constants.TAB_DEFS)[library].label
                        })
                    ]
                })
            }),
            toc && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " _eL2Ky171 -aGzJ7c-1Za9w171 -aGzJ7c-Qlsn9mNcQZb171 _fb171 _2d171 _Pa171 _EF171 -_7PloMd-CoPtrc171 __Ya171",
                style: {
                    animationName: fadeIn,
                    animationTimeline: 'scroll()',
                    animationRange,
                    animationPlayState: isTransitioning ? 'paused' : undefined
                },
                children: toc
            }),
            library !== 'react-aria' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeToggle, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _s2.DialogTrigger), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.ActionButton), {
                        "aria-label": "Navigation",
                        isQuiet: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuHamburgerDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ModalOverlay), {
                        // Keep in the DOM after it has opened once to preserve scroll position.
                        isExiting: !isOpen && wasOpen,
                        style: {
                            display: !isOpen ? 'none' : undefined,
                            // @ts-ignore
                            viewTransitionName: 'search-menu-underlay'
                        },
                        className: " _Pa171 Wr171 _Er171 Za171 FKem6Ob171 _Bb171 -Ovbhqd-g_g171 gEzkoQe171",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Modal), {
                            className: " _Pe171 Wr171 _Er171 Za171 FE9bXU171",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2.Provider), {
                                colorScheme: colorScheme,
                                background: "layer-2",
                                styles: " Fb171",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileSearchMenu, {})
                            })
                        })
                    })
                ]
            })
        ]
    });
}

},{"0":"4oKuc","1":"4oKuc","2":"4oKuc","3":"4oKuc","4":"4oKuc","5":"4oKuc","6":"4oKuc","7":"4oKuc","8":"4oKuc","9":"4oKuc","10":"4oKuc","11":"4oKuc","12":"4oKuc","react/jsx-runtime":"2Is6Z","@react-spectrum/s2":[["ActionButton","lNDRs"],["DialogTrigger","eu4Kx"],["pressScale","8Ufux"],["Provider","31Rc2"]],"react-aria-components":[["Button","9G5XO"],["Link","fOCdV"],["Modal","29rOq"],["ModalOverlay","29rOq"]],"@react-spectrum/s2/icons/Contrast":"jAv02","./pageUtils":"73Jzg","./library":"a5H2j","@react-spectrum/s2/icons/Lighten":"8rFkP","@react-spectrum/s2/icons/MenuHamburger":"bneuv","react":"a1TxN","./constants":"hYP4Q","@react-aria/utils":"k6VV7","./Router":"jI9xq","./SettingsContext":"7F6kW","./SearchMenu.css":"fjiYx","9e1014ecc3960d12":"6bpM5","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fjiYx":[function() {},{}],"6bpM5":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _rscHelpers = require("@parcel/runtime-rsc/rsc-helpers");
var _reactDom = require("react-dom");
(0, _reactDom.preinit)(module.bundle.resolve("igRYP"), {
    as: 'style',
    precedence: 'default'
});
let promise = Promise.all([
    module.bundle.load("awzdE"),
    module.bundle.load("kWrGa"),
    module.bundle.load("fqSlw"),
    module.bundle.load("hHkzJ"),
    module.bundle.load("lo1tk"),
    module.bundle.load("373ut"),
    module.bundle.load("68Spg"),
    module.bundle.load("blC0m")
]).then(()=>{
    let originalModule = module.bundle.root("7ohac");
    let resources = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("awzdE")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "stylesheet",
                href: module.bundle.resolve("igRYP"),
                precedence: "default"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("kWrGa")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("fqSlw")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("hHkzJ")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("lo1tk")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("373ut")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("68Spg")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "modulepreload",
                href: module.bundle.resolve("blC0m")
            })
        ]
    });
    let res = (0, _rscHelpers.createResourcesProxy)(originalModule, false, resources);
    return res;
});
module.exports = promise;

},{"react/jsx-runtime":"2Is6Z","@parcel/runtime-rsc/rsc-helpers":"iKyDQ","react-dom":"gC2PC"}],"iKyDQ":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /* eslint-disable react/react-in-jsx-scope */ /* @jsxRuntime automatic */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResourcesProxy", ()=>createResourcesProxy);
parcelHelpers.export(exports, "waitForCSS", ()=>waitForCSS);
var _jsxRuntime = require("react/jsx-runtime");
function createResourcesProxy(module, esModule, resources, bootstrapScript) {
    if (typeof module === 'function') return createResourcesValueProxy(module, resources, bootstrapScript);
    return new Proxy(module, {
        get (target, prop, receiver) {
            if (prop === '__esModule' && esModule) return true;
            let value = Reflect.get(target, prop, receiver);
            return createResourcesValueProxy(value, resources, bootstrapScript);
        }
    });
}
let cache = new WeakMap();
function createResourcesValueProxy(value, resources, bootstrapScript) {
    if (typeof value === 'function') {
        let cached = cache.get(value);
        if (cached) return cached;
        // Detect reads of `Component.prototype.isReactComponent` or `Component.$$typeof`
        // prior to the function being called as an indication that this is a React component.
        // If so, inject the resources as a sibling of the return value.
        let isReactComponent = false;
        let prototypeProxy;
        if (typeof value.prototype === 'object') prototypeProxy = new Proxy(value.prototype, {
            get (target, prop, receiver) {
                if (prop === 'isReactComponent') isReactComponent = true;
                return Reflect.get(target, prop, receiver);
            }
        });
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                if (prototypeProxy && prop === 'prototype' && Object.getOwnPropertyDescriptor(target, 'prototype').configurable) return prototypeProxy;
                if (prop === '$$typeof') isReactComponent = true;
                if (bootstrapScript && prop === 'bootstrapScript') return bootstrapScript;
                return Reflect.get(target, prop, receiver);
            },
            apply (target, thisArg, args) {
                let result = Reflect.apply(target, thisArg, args);
                if (isReactComponent) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        resources,
                        result
                    ]
                });
                return result;
            }
        });
        cache.set(value, proxy);
        return proxy;
    } else if (value && typeof value === 'object') {
        let cached = cache.get(value);
        if (cached) return cached;
        let proxy = new Proxy(value, {
            get (target, prop, receiver) {
                let value = Reflect.get(target, prop, receiver);
                return createResourcesValueProxy(value, resources, bootstrapScript);
            }
        });
        cache.set(value, proxy);
        return proxy;
    }
    return value;
}
function waitForCSS(url) {
    return new Promise((resolve, reject)=>{
        if (typeof document === 'undefined') return resolve();
        // Find a link element corresponding to this URL.
        let link = document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(url)}"]`);
        if (!link) return resolve();
        // If the link element already has a stylesheet associated with it, then it is already loaded.
        if (link.sheet) return resolve();
        link.addEventListener('load', ()=>{
            resolve();
        });
        link.addEventListener('error', (e)=>{
            reject(e);
        });
    });
}

},{"react/jsx-runtime":"2Is6Z","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9wkXQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    module.bundle.load("blC0m"),
    module.bundle.load("68Spg"),
    module.bundle.load("373ut"),
    module.bundle.load("lo1tk"),
    module.bundle.load("hHkzJ"),
    module.bundle.load("fqSlw"),
    module.bundle.load("kWrGa"),
    require("722e351a2d2f317a")(module.bundle.resolve("igRYP")),
    module.bundle.load("awzdE")
]).then(()=>module.bundle.root('7ohac'));

},{"722e351a2d2f317a":"819rl"}],"819rl":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"e87h6"}],"e87h6":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},[], null, "parcelRequire7f0c", {}, "./", "/")

//# sourceMappingURL=Autocomplete.7fdea5c5.js.map
